import React, { useState, useEffect, useCallback, useMemo } from "react";
import Header from "../Header";
import { useNavigate } from "react-router-dom";
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { app } from "../../firebase-config";
import styles from "./AdminAccount.module.css";
import DeleteConfirmModal from "../DeleteConfirmModal";

// ============================================
// ICON COMPONENTS
// ============================================

const Icons = {
  Users: () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>),
  Activity: () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>),
  TrendingUp: () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>),
  DollarSign: () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>),
  Mail: () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>),
  Bell: () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>),
  Award: () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="8" r="7"/><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"/></svg>),
  Smartphone: () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="5" y="2" width="14" height="20" rx="2" ry="2"/><line x1="12" y1="18" x2="12.01" y2="18"/></svg>),
  AlertTriangle: () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>),
  RefreshCw: () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>),
  Camera: () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>),
  Check: () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="20 6 9 17 4 12"/></svg>),
  X: () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>),
  Download: () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>),
  Filter: () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>),
  BarChart: () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="20" x2="12" y2="10"/><line x1="18" y1="20" x2="18" y2="4"/><line x1="6" y1="20" x2="6" y2="16"/></svg>),
  Search: () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>),
  Send: () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>),
  Terminal: () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="4 17 10 11 4 5"/><line x1="12" y1="19" x2="20" y2="19"/></svg>),
  Zap: () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>),
};

// ============================================
// CHART COMPONENTS
// ============================================

const MiniLineChart = ({ data, dataKey, color = "#61d89e", height = 60, showAxes = false }) => {
  if (!data || data.length < 2) return <div className={styles.chartPlaceholder}>No data</div>;
  const values = data.map(d => d[dataKey] || 0);
  const max = Math.max(...values, 1);
  const min = Math.min(...values, 0);
  const range = max - min || 1;
  
  const leftPadding = showAxes ? 40 : 4;
  const bottomPadding = showAxes ? 20 : 4;
  const topPadding = 4;
  const rightPadding = 4;
  const width = 200;
  const chartWidth = width - leftPadding - rightPadding;
  const chartHeight = height - topPadding - bottomPadding;
  
  const points = values.map((v, i) => {
    const x = leftPadding + (i / (values.length - 1)) * chartWidth;
    const y = topPadding + chartHeight - ((v - min) / range) * chartHeight;
    return { x, y, value: v };
  });
  const pathD = points.map((p, i) => `${i === 0 ? 'M' : 'L'} ${p.x},${p.y}`).join(' ');
  const areaD = `${pathD} L ${points[points.length - 1].x},${topPadding + chartHeight} L ${leftPadding},${topPadding + chartHeight} Z`;
  
  const yLabels = showAxes ? [max, Math.round((max + min) / 2), min] : [];
  const xLabels = showAxes && data[0]?.date ? [
    { pos: 0, label: data[0].date?.slice(-5) || '' },
    { pos: 0.5, label: data[Math.floor(data.length / 2)]?.date?.slice(-5) || '' },
    { pos: 1, label: data[data.length - 1]?.date?.slice(-5) || '' }
  ] : [];

  return (
    <svg width="100%" height={height} viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="xMidYMid meet">
      <defs>
        <linearGradient id={`gradient-${color.replace('#', '')}`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="0.3"/>
          <stop offset="100%" stopColor={color} stopOpacity="0"/>
        </linearGradient>
      </defs>
      {showAxes && yLabels.map((label, i) => (
        <text key={`y-${i}`} x={leftPadding - 4} y={topPadding + (i / (yLabels.length - 1)) * chartHeight} textAnchor="end" dominantBaseline="middle" className={styles.axisLabel}>
          {typeof label === 'number' ? (label >= 1000 ? `${(label / 1000).toFixed(0)}k` : label) : label}
        </text>
      ))}
      {showAxes && xLabels.map((item, i) => (
        <text key={`x-${i}`} x={leftPadding + item.pos * chartWidth} y={height - 4} textAnchor="middle" className={styles.axisLabel}>{item.label}</text>
      ))}
      {showAxes && (<><line x1={leftPadding} y1={topPadding} x2={leftPadding} y2={topPadding + chartHeight} stroke="#444" strokeWidth="1" /><line x1={leftPadding} y1={topPadding + chartHeight} x2={leftPadding + chartWidth} y2={topPadding + chartHeight} stroke="#444" strokeWidth="1" /></>)}
      <path fill={`url(#gradient-${color.replace('#', '')})`} d={areaD} />
      <path fill="none" stroke={color} strokeWidth="2" d={pathD} />
    </svg>
  );
};

const DonutChart = ({ data, size = 120 }) => {
  if (!data || data.length === 0) return <div className={styles.chartPlaceholder}>No data</div>;
  const total = data.reduce((sum, d) => sum + d.value, 0);
  const radius = size / 2 - 15;
  const circumference = 2 * Math.PI * radius;
  let currentAngle = -90;
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      {data.map((item, i) => {
        const percentage = item.value / total;
        const angle = percentage * 360;
        const strokeDasharray = `${percentage * circumference} ${circumference}`;
        const rotation = currentAngle;
        currentAngle += angle;
        return (<circle key={i} cx={size / 2} cy={size / 2} r={radius} fill="none" stroke={item.color} strokeWidth="16" strokeDasharray={strokeDasharray} transform={`rotate(${rotation} ${size / 2} ${size / 2})`} />);
      })}
      <text x={size / 2} y={size / 2} textAnchor="middle" dy="0.35em" className={styles.donutCenter}>{total}</text>
    </svg>
  );
};

const HorizontalBarChart = ({ data, maxValue }) => {
  if (!data || Object.keys(data).length === 0) return <div className={styles.chartPlaceholder}>No data</div>;
  const max = maxValue || Math.max(...Object.values(data), 1);
  const sorted = Object.entries(data).sort((a, b) => b[1] - a[1]);
  return (
    <div className={styles.horizontalBarChart}>
      {sorted.map(([label, value]) => (
        <div key={label} className={styles.hBarRow}>
          <span className={styles.hBarLabel}>{label}</span>
          <div className={styles.hBarTrack}><div className={styles.hBarFill} style={{ width: `${(value / max) * 100}%` }} /></div>
          <span className={styles.hBarValue}>{value}</span>
        </div>
      ))}
    </div>
  );
};

const FunnelChart = ({ data, outcomes }) => {
  if (!data || data.length === 0) return <div className={styles.chartPlaceholder}>No funnel data</div>;
  const maxCount = Math.max(...data.map(d => d.count), 1);
  return (
    <div className={styles.funnelChart}>
      {data.map((stage, i) => {
        const widthPercent = (stage.count / maxCount) * 100;
        const hue = 160 - i * 20;
        return (
          <div key={stage.stage} className={styles.funnelStage}>
            <div className={styles.funnelBar} style={{ width: `${Math.max(widthPercent, 15)}%`, backgroundColor: `hsl(${hue}, 65%, 45%)` }}>
              <span className={styles.funnelLabel}>{stage.stage}</span>
              <span className={styles.funnelValue}>{stage.count.toLocaleString()}</span>
            </div>
            {i < data.length - 1 && <div className={styles.funnelDropoff}>↓ {data[i + 1].percentage}% conversion</div>}
          </div>
        );
      })}
      {outcomes && (
        <div className={styles.funnelOutcomes}>
          <div className={styles.funnelOutcome}><span className={styles.outcomeValue} style={{ color: '#f4b400' }}>{outcomes.premium.count}</span><span className={styles.outcomeLabel}>Premium ({outcomes.premium.rate}%)</span></div>
          <div className={styles.funnelOutcome}><span className={styles.outcomeValue} style={{ color: '#a855f7' }}>{outcomes.quit.count}</span><span className={styles.outcomeLabel}>Quit Success ({outcomes.quit.rate}%)</span></div>
        </div>
      )}
    </div>
  );
};

const RetentionTable = ({ cohorts, averages }) => {
  if (!cohorts || cohorts.length === 0) return <div className={styles.chartPlaceholder}>No retention data</div>;
  const getCellClass = (value) => {
    if (value === null) return '';
    if (value >= 50) return styles.retentionHigh;
    if (value >= 30) return styles.retentionMedium;
    if (value >= 15) return styles.retentionLow;
    return styles.retentionVeryLow;
  };
  return (
    <div className={styles.tableContainer}>
      <table className={styles.dataTable}>
        <thead><tr><th>Cohort</th><th>Size</th><th>D1</th><th>D7</th><th>D14</th><th>D30</th></tr></thead>
        <tbody>
          {cohorts.map(cohort => (
            <tr key={cohort.week}>
              <td><div>{cohort.week}</div><div className={styles.subText}>{cohort.weekStart}</div></td>
              <td>{cohort.size}</td>
              <td className={getCellClass(cohort.d1)}>{cohort.d1}%</td>
              <td className={getCellClass(cohort.d7)}>{cohort.d7 !== null ? `${cohort.d7}%` : '—'}</td>
              <td className={getCellClass(cohort.d14)}>{cohort.d14 !== null ? `${cohort.d14}%` : '—'}</td>
              <td className={getCellClass(cohort.d30)}>{cohort.d30 !== null ? `${cohort.d30}%` : '—'}</td>
            </tr>
          ))}
          {averages && <tr className={styles.averageRow}><td><strong>Average</strong></td><td>—</td><td><strong>{averages.d1}%</strong></td><td><strong>{averages.d7}%</strong></td><td><strong>{averages.d14}%</strong></td><td><strong>{averages.d30}%</strong></td></tr>}
        </tbody>
      </table>
    </div>
  );
};

const ActivityFeed = ({ activities, onRefresh, loading }) => {
  const typeConfig = { signup: { icon: '👤', color: '#3b82f6' }, purchase: { icon: '💰', color: '#22c55e' }, lead: { icon: '📧', color: '#6366f1' }, quit: { icon: '🎉', color: '#a855f7' } };
  return (
    <div className={styles.activityFeed}>
      <div className={styles.feedHeader}><h3>Live Activity (24h)</h3><button onClick={onRefresh} className={styles.btnSmall} disabled={loading}><Icons.RefreshCw /> {loading ? '...' : 'Refresh'}</button></div>
      <div className={styles.feedList}>
        {!activities ? <div className={styles.feedLoading}>Loading activity...</div> : activities.length === 0 ? <div className={styles.feedEmpty}>No recent activity</div> : activities.slice(0, 15).map((activity, i) => (
          <div key={`${activity.type}-${activity.timestamp}-${i}`} className={styles.feedItem} style={{ borderLeftColor: typeConfig[activity.type]?.color || '#888' }}>
            <span className={styles.feedIcon}>{typeConfig[activity.type]?.icon || '📌'}</span>
            <div className={styles.feedContent}><span className={styles.feedMessage}>{activity.message}</span>{activity.detail && <span className={styles.feedDetail}>{activity.detail}</span>}{activity.email && <span className={styles.feedEmail}>{activity.email}</span>}</div>
            <span className={styles.feedTime}>{formatTimeAgo(activity.timestamp)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

const LTVCard = ({ data }) => {
  if (!data) return <div className={styles.chartPlaceholder}>Loading LTV data...</div>;
  const { summary, metrics } = data;
  return (
    <div className={styles.ltvCard}>
      <div className={styles.ltvHeader}><div className={styles.ltvMain}><span className={styles.ltvLabel}>Estimated LTV</span><span className={styles.ltvValue}>${metrics.estimatedLTV}</span></div><div className={styles.ltvMain}><span className={styles.ltvLabel}>Conversion Rate</span><span className={styles.ltvValue} style={{ color: '#3b82f6' }}>{metrics.conversionRate}%</span></div></div>
      <div className={styles.ltvMetrics}><div className={styles.ltvMetric}><span className={styles.ltvMetricValue}>${metrics.avgRevenuePerPayingUser}</span><span className={styles.ltvMetricLabel}>ARPU (Paying)</span></div><div className={styles.ltvMetric}><span className={styles.ltvMetricValue}>{metrics.avgOrdersPerPayingUser.toFixed(1)}</span><span className={styles.ltvMetricLabel}>Avg Orders</span></div><div className={styles.ltvMetric}><span className={styles.ltvMetricValue}>{metrics.estimatedLifespanMonths} mo</span><span className={styles.ltvMetricLabel}>Est. Lifespan</span></div><div className={styles.ltvMetric}><span className={styles.ltvMetricValue}>{metrics.monthlyRetentionRate}%</span><span className={styles.ltvMetricLabel}>30d Retention</span></div></div>
      <div className={styles.ltvSummary}><span>Total Revenue: <strong>${summary.totalRevenue.toLocaleString()}</strong></span><span>Paying Users: <strong>{summary.payingUsers} / {summary.totalUsers}</strong></span></div>
    </div>
  );
};

const ComparisonBadge = ({ current, previous }) => {
  if (previous === undefined || previous === null) return null;
  const change = previous > 0 ? ((current - previous) / previous * 100) : (current > 0 ? 100 : 0);
  const isPositive = change >= 0;
  return <span className={`${styles.comparisonBadge} ${isPositive ? styles.badgePositive : styles.badgeNegative}`}>{isPositive ? '↑' : '↓'} {Math.abs(change).toFixed(1)}%</span>;
};

const RadialGauge = ({ usedMs, limitMs, calibrated, size = 180 }) => {
  if (!calibrated) return <div className={styles.chartPlaceholder} style={{ width: size, height: size, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Calibrating...</div>;
  const cx = size / 2, cy = size / 2;
  const trackRadius = size / 2 - 20;
  const ringRadius = size / 2 - 38;
  const trackCirc = 2 * Math.PI * trackRadius;
  const ringCirc = 2 * Math.PI * ringRadius;
  const inRange = Math.min(usedMs, limitMs);
  const excess = Math.max(0, usedMs - limitMs);
  const inRangeFrac = limitMs > 0 ? Math.min(inRange / limitMs, 1) : 0;
  const excessFrac = limitMs > 0 ? Math.min(excess / limitMs, 1) : 0;
  const usedSec = (usedMs / 1000).toFixed(1);
  const limitSec = (limitMs / 1000).toFixed(1);
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      <circle cx={cx} cy={cy} r={trackRadius} fill="none" stroke="#2b2c2b" strokeWidth="14" />
      <circle cx={cx} cy={cy} r={ringRadius} fill="none" stroke="#2b2c2b" strokeWidth="10" />
      <circle cx={cx} cy={cy} r={trackRadius} fill="none" stroke="#61d89e" strokeWidth="14"
        strokeDasharray={`${inRangeFrac * trackCirc} ${trackCirc}`}
        strokeLinecap="round" transform={`rotate(-90 ${cx} ${cy})`} />
      {excess > 0 && <circle cx={cx} cy={cy} r={ringRadius} fill="none" stroke="#e08e8e" strokeWidth="10"
        strokeDasharray={`${excessFrac * ringCirc} ${ringCirc}`}
        strokeLinecap="round" transform={`rotate(-90 ${cx} ${cy})`} />}
      <text x={cx} y={cy - 10} textAnchor="middle" className={styles.radialCenter}>Limit: {limitSec}s</text>
      <text x={cx} y={cy + 14} textAnchor="middle" className={styles.radialSubtext}>Today: {usedSec}s</text>
    </svg>
  );
};

const VerticalBarChart = ({ data, dataKey, labelKey, color = '#61d89e', height = 200, timeMode = 'day' }) => {
  if (!data || data.length === 0) return <div className={styles.chartPlaceholder}>No data</div>;
  const values = data.map(d => d[dataKey] || 0);
  const max = Math.max(...values, 1);
  const leftPad = 45, rightPad = 8, topPad = 8, bottomPad = 24;
  const svgWidth = 600;
  const chartWidth = svgWidth - leftPad - rightPad;
  const chartHeight = height - topPad - bottomPad;
  const barGap = 2;
  const barWidth = Math.max(4, (chartWidth / data.length) - barGap);

  const formatLabel = (bucket) => {
    if (!bucket) return '';
    const d = new Date(bucket);
    if (timeMode === 'hour') return `${d.getUTCHours()}:00`;
    if (timeMode === 'month') return d.toLocaleDateString('en-US', { month: 'short', timeZone: 'UTC' });
    return `${d.getUTCMonth() + 1}/${d.getUTCDate()}`;
  };

  const yLabels = [max, Math.round(max / 2), 0];

  return (
    <svg width="100%" height={height} viewBox={`0 0 ${svgWidth} ${height}`} preserveAspectRatio="xMidYMid meet">
      {yLabels.map((label, i) => {
        const y = topPad + (i / (yLabels.length - 1)) * chartHeight;
        return (<g key={`y-${i}`}><line x1={leftPad} y1={y} x2={svgWidth - rightPad} y2={y} className={styles.vBarGrid} /><text x={leftPad - 4} y={y} textAnchor="end" dominantBaseline="middle" className={styles.vBarLabel}>{label >= 60000 ? `${(label / 60000).toFixed(0)}m` : label >= 1000 ? `${(label / 1000).toFixed(0)}k` : label}</text></g>);
      })}
      {data.map((d, i) => {
        const val = d[dataKey] || 0;
        const barH = (val / max) * chartHeight;
        const x = leftPad + i * (barWidth + barGap) + barGap / 2;
        const y = topPad + chartHeight - barH;
        const showLabel = data.length <= 12 || i % Math.ceil(data.length / 10) === 0;
        return (<g key={i}>
          <rect x={x} y={y} width={barWidth} height={barH} fill={color} rx={Math.min(4, barWidth / 2)} />
          {showLabel && <text x={x + barWidth / 2} y={height - 4} textAnchor="middle" className={styles.vBarLabel}>{formatLabel(d[labelKey])}</text>}
        </g>);
      })}
    </svg>
  );
};

const StatCard = ({ label, value, subtitle, trend, trendLabel, icon: Icon, color = "green", comparison }) => {
  const colorClass = styles[`stat${color.charAt(0).toUpperCase() + color.slice(1)}`] || styles.statGreen;
  return (
    <div className={`${styles.statCard} ${colorClass}`}>
      <div className={styles.statHeader}>{Icon && <div className={styles.statIcon}><Icon /></div>}<div className={styles.statLabel}>{label}</div></div>
      <div className={styles.statValueRow}><div className={styles.statValue}>{value}</div>{comparison && <ComparisonBadge current={comparison.current} previous={comparison.previous} />}</div>
      {subtitle && <div className={styles.statSubtitle}>{subtitle}</div>}
      {trend !== undefined && <div className={`${styles.statTrend} ${trend >= 0 ? styles.trendPositive : styles.trendNegative}`}>{trend >= 0 ? '↑' : '↓'} {Math.abs(trend).toFixed(1)}% {trendLabel || ''}</div>}
    </div>
  );
};

const DataTable = ({ columns, data, onRowClick, selectedId, emptyMessage = "No data" }) => {
  if (!data || data.length === 0) return <div className={styles.emptyTable}>{emptyMessage}</div>;
  return (
    <div className={styles.tableContainer}>
      <table className={styles.dataTable}>
        <thead><tr>{columns.map(col => <th key={col.key} style={col.width ? { width: col.width } : {}}>{col.label}</th>)}</tr></thead>
        <tbody>
          {data.map((row, i) => (
            <tr key={row.id || i} onClick={() => onRowClick && onRowClick(row)} className={`${styles.tableRow} ${selectedId === row.id ? styles.tableRowSelected : ''} ${onRowClick ? styles.tableRowClickable : ''}`}>
              {columns.map(col => <td key={col.key}>{col.render ? col.render(row[col.key], row) : row[col.key]}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const InfoItem = ({ label, value }) => <div className={styles.infoItem}><span className={styles.infoLabel}>{label}</span><span className={styles.infoValue}>{value}</span></div>;

// ============================================
// HELPER FUNCTIONS
// ============================================

function formatTimeAgo(timestamp) {
  if (!timestamp) return 'Never';
  const now = Date.now();
  const diff = now - timestamp;
  const minutes = Math.floor(diff / 60000);
  const hours = Math.floor(diff / 3600000);
  const days = Math.floor(diff / 86400000);
  if (minutes < 1) return 'Just now';
  if (minutes < 60) return `${minutes}m ago`;
  if (hours < 24) return `${hours}h ago`;
  if (days < 7) return `${days}d ago`;
  return new Date(timestamp).toLocaleDateString();
}

function formatCurrency(amount) { return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount); }
function formatNumber(num) { if (num >= 1000000) return (num / 1000000).toFixed(1) + 'M'; if (num >= 1000) return (num / 1000).toFixed(1) + 'K'; return num?.toString() || '0'; }

function exportToCSV(data, filename) {
  if (!data || data.length === 0) { alert('No data to export'); return; }
  const headers = Object.keys(data[0]);
  const csvRows = [headers.join(','), ...data.map(row => headers.map(h => { let val = row[h]; if (val === null || val === undefined) val = ''; if (typeof val === 'object') val = JSON.stringify(val); val = String(val).replace(/"/g, '""'); if (val.includes(',') || val.includes('"') || val.includes('\n')) val = `"${val}"`; return val; }).join(','))];
  const csv = csvRows.join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${filename}-${new Date().toISOString().split('T')[0]}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

// ============================================
// TESTING PANEL COMPONENT
// ============================================

// Default notification buckets (fallback if cloud function fails)
const DEFAULT_NOTIFICATION_BUCKETS = [
  { id: 'logReminder', title: 'Time to log! 📝', body: 'Track your progress and stay on top of your goals.', isGuest: false },
  { id: 'streak', title: '🔥 Keep your streak alive!', body: "You're on a streak! Don't break it now.", isGuest: false },
  { id: 'comeback', title: 'We miss you! 👋', body: "It's been a while. Ready to get back on track?", isGuest: false },
  { id: 'overLimitToday', title: 'Heads up! ⚠️', body: "You've exceeded your limit today.", isGuest: false },
  { id: 'cutDownTrendSuccess', title: 'Great progress! 📉', body: "You've cut down over the past few days!", isGuest: false },
  { id: 'quitMilestone', title: 'Quit milestone! 🎉', body: 'Days smoke-free! Amazing work.', isGuest: false },
  { id: 'review', title: 'Enjoying Qwytt? ⭐', body: "We'd love to hear your feedback!", isGuest: false },
  { id: 'devicePromo', title: 'Get the Qwytt device 📱', body: 'Track automatically with our smart sensor.', isGuest: false },
  { id: 'guestReminder', title: "Don't forget to log! 📝", body: 'Stay on track with your goals.', isGuest: true },
  { id: 'guestMotivation', title: "You've got this! 💪", body: 'Every day is a step toward a healthier you.', isGuest: true },
  { id: 'guestReview', title: 'Enjoying the app? ⭐', body: 'Leave us a review!', isGuest: true },
  { id: 'guestDevicePromo', title: 'Upgrade your tracking 📱', body: 'Get the Qwytt device for automatic logging.', isGuest: true },
];

const TestingPanel = ({ functions }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState(null);
  const [searchLoading, setSearchLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [notificationBuckets, setNotificationBuckets] = useState(DEFAULT_NOTIFICATION_BUCKETS);
  const [selectedBucket, setSelectedBucket] = useState('logReminder');
  const [customTitle, setCustomTitle] = useState('');
  const [customBody, setCustomBody] = useState('');
  const [useCustomMessage, setUseCustomMessage] = useState(false);
  const [emailAddress, setEmailAddress] = useState('');
  const [emailTemplate, setEmailTemplate] = useState('welcome');
  const [customSubject, setCustomSubject] = useState('');
  const [customHtml, setCustomHtml] = useState('');
  const [testResults, setTestResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [systemHealth, setSystemHealth] = useState(null);
  const [recentUsers, setRecentUsers] = useState([]);
  const [recentGuests, setRecentGuests] = useState([]);

  useEffect(() => {
    const loadBuckets = async () => {
      try {
        const getBuckets = httpsCallable(functions, 'adminGetNotificationBuckets');
        const result = await getBuckets();
        if (result.data.buckets && result.data.buckets.length > 0) {
          setNotificationBuckets(result.data.buckets);
        }
      } catch (err) { 
        console.error('Error loading buckets, using defaults:', err);
        // Keep using DEFAULT_NOTIFICATION_BUCKETS
      }
    };
    loadBuckets();
  }, [functions]);

  useEffect(() => {
    const loadRecent = async () => {
      try {
        const [usersRes, guestsRes] = await Promise.all([
          httpsCallable(functions, 'adminGetRecentUsers')({ limit: 10 }),
          httpsCallable(functions, 'adminGetRecentGuests')({ limit: 10 })
        ]);
        setRecentUsers(usersRes.data.users);
        setRecentGuests(guestsRes.data.guests);
      } catch (err) { console.error('Error loading recent:', err); }
    };
    loadRecent();
  }, [functions]);

  const addResult = (result) => setTestResults(prev => [{ id: Date.now(), timestamp: new Date().toISOString(), ...result }, ...prev.slice(0, 19)]);

  const handleSearch = async () => {
    if (!searchQuery.trim()) return;
    setSearchLoading(true);
    try {
      const search = httpsCallable(functions, 'adminSearchUsers');
      const result = await search({ query: searchQuery });
      setSearchResults(result.data.results);
    } catch (err) { addResult({ type: 'error', action: 'search', error: err.message }); }
    finally { setSearchLoading(false); }
  };

  const handleLookup = async (identifier, isEmail = false) => {
    setIsLoading(true);
    try {
      const lookup = httpsCallable(functions, 'adminLookupUser');
      const result = await lookup(isEmail ? { email: identifier } : { userId: identifier });
      if (result.data.found) {
        setSelectedUser(result.data);
        addResult({ type: 'success', action: 'lookup', message: `Found ${result.data.type}: ${result.data.email || result.data.id}` });
      } else { addResult({ type: 'warning', action: 'lookup', message: 'User not found' }); }
    } catch (err) { addResult({ type: 'error', action: 'lookup', error: err.message }); }
    finally { setIsLoading(false); }
  };

  const handleSendPush = async () => {
    if (!selectedUser) { addResult({ type: 'error', action: 'push', error: 'No user selected' }); return; }
    setIsLoading(true);
    try {
      const sendPush = httpsCallable(functions, 'adminSendTestPush');
      const payload = { userId: selectedUser.id, bucket: selectedBucket };
      if (useCustomMessage) { payload.customTitle = customTitle; payload.customBody = customBody; }
      const result = await sendPush(payload);
      addResult({ type: result.data.successCount > 0 ? 'success' : 'error', action: 'push', message: `Push to ${selectedUser.email || selectedUser.id}: ${result.data.successCount}/${result.data.tokensAttempted} delivered`, details: result.data });
    } catch (err) { addResult({ type: 'error', action: 'push', error: err.message }); }
    finally { setIsLoading(false); }
  };

  const handleSendPushGuest = async (deviceId) => {
    setIsLoading(true);
    try {
      const sendPush = httpsCallable(functions, 'adminSendTestPushGuest');
      const result = await sendPush({ deviceId, bucket: selectedBucket, customTitle: useCustomMessage ? customTitle : undefined, customBody: useCustomMessage ? customBody : undefined });
      addResult({ type: result.data.success ? 'success' : 'error', action: 'push-guest', message: `Push to guest ${deviceId.slice(0, 8)}...: ${result.data.success ? 'delivered' : 'failed'}`, details: result.data });
    } catch (err) { addResult({ type: 'error', action: 'push-guest', error: err.message }); }
    finally { setIsLoading(false); }
  };

  const handleSendEmail = async () => {
    const targetEmail = emailAddress || selectedUser?.email;
    if (!targetEmail) { addResult({ type: 'error', action: 'email', error: 'No email address' }); return; }
    setIsLoading(true);
    try {
      const sendEmail = httpsCallable(functions, 'adminSendTestEmail');
      const result = await sendEmail({ email: targetEmail, templateType: emailTemplate, subject: customSubject || undefined, htmlContent: customHtml || undefined, templateData: { name: selectedUser?.displayName || 'Friend' } });
      addResult({ type: result.data.success ? 'success' : 'error', action: 'email', message: `Email to ${targetEmail}: ${result.data.success ? 'sent' : 'failed'}`, details: result.data });
    } catch (err) { addResult({ type: 'error', action: 'email', error: err.message }); }
    finally { setIsLoading(false); }
  };

  const handleCheckHealth = async () => {
    setIsLoading(true);
    try {
      const checkHealth = httpsCallable(functions, 'adminGetSystemHealth');
      const result = await checkHealth();
      setSystemHealth(result.data);
      addResult({ type: result.data.status === 'healthy' ? 'success' : 'warning', action: 'health', message: `System: ${result.data.status}`, details: result.data });
    } catch (err) { addResult({ type: 'error', action: 'health', error: err.message }); }
    finally { setIsLoading(false); }
  };

  const handleTestFCM = async () => {
    setIsLoading(true);
    try {
      const testFCM = httpsCallable(functions, 'adminTestFCM');
      const result = await testFCM();
      addResult({ type: result.data.success ? 'success' : 'error', action: 'fcm-test', message: result.data.message });
    } catch (err) { addResult({ type: 'error', action: 'fcm-test', error: err.message }); }
    finally { setIsLoading(false); }
  };

  const selectedBucketPreview = notificationBuckets.find(b => b.id === selectedBucket);

  return (
    <div className={styles.testingPanel}>
      <div className={styles.testingGrid}>
        {/* Left Column - User Selection */}
        <div className={styles.testingSection}>
          <h3><Icons.Search /> Find User</h3>
          <div className={styles.searchBox}>
            <input type="text" placeholder="Search by email, username, or ID..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} onKeyDown={e => e.key === 'Enter' && handleSearch()} className={styles.searchInput} />
            <button onClick={handleSearch} disabled={searchLoading} className={styles.btnSmall}>{searchLoading ? '...' : <Icons.Search />}</button>
          </div>
          {searchResults && (
            <div className={styles.searchResults}>
              {searchResults.length === 0 ? <div className={styles.noResults}>No results found</div> : searchResults.map(result => (
                <div key={result.id} className={`${styles.searchResult} ${selectedUser?.id === result.id ? styles.searchResultSelected : ''}`} onClick={() => handleLookup(result.id)}>
                  <span className={styles.resultEmail}>{result.email || result.name}</span>
                  <span className={styles.resultType}>{result.type}</span>
                </div>
              ))}
            </div>
          )}
          {selectedUser && (
            <div className={styles.selectedUserCard}>
              <div className={styles.selectedUserHeader}><strong>{selectedUser.displayName || selectedUser.email || selectedUser.id}</strong><button onClick={() => setSelectedUser(null)} className={styles.btnIcon}>×</button></div>
              <div className={styles.selectedUserInfo}>
                <div>Type: <span className={styles.badge}>{selectedUser.type}</span></div>
                {selectedUser.email && <div>Email: {selectedUser.email}</div>}
                {selectedUser.platform && <div>Platform: {selectedUser.platform}</div>}
                <div>Push: {selectedUser.canSendPush ? <span className={styles.badgeSuccess}>{selectedUser.tokenCount} tokens</span> : <span className={styles.badgeError}>No tokens</span>}</div>
                <div>Email: {selectedUser.canSendEmail ? <span className={styles.badgeSuccess}>Available</span> : <span className={styles.badgeError}>Unavailable</span>}</div>
              </div>
            </div>
          )}
          <div className={styles.quickSelect}><h4>Recent Users</h4><div className={styles.quickSelectList}>{recentUsers.slice(0, 5).map(user => (<button key={user.id} className={styles.quickSelectBtn} onClick={() => handleLookup(user.id)}><span>{user.email || user.username || user.id.slice(0, 8)}</span>{user.canSendPush && <span className={styles.tokenDot}>●</span>}</button>))}</div></div>
          <div className={styles.quickSelect}><h4>Recent Guests</h4><div className={styles.quickSelectList}>{recentGuests.slice(0, 5).map(guest => (<button key={guest.id} className={styles.quickSelectBtn} onClick={() => handleSendPushGuest(guest.id)} disabled={!guest.canSendPush}><span>{guest.id.slice(0, 12)}...</span>{guest.canSendPush && <span className={styles.tokenDot}>●</span>}</button>))}</div></div>
        </div>

        {/* Middle Column - Actions */}
        <div className={styles.testingSection}>
          <h3><Icons.Bell /> Send Push Notification</h3>
          <div className={styles.formGroup}>
            <label>Notification Type</label>
            <select value={selectedBucket} onChange={e => setSelectedBucket(e.target.value)} className={styles.selectInput}>
              {notificationBuckets.map(bucket => <option key={bucket.id} value={bucket.id}>{bucket.id} {bucket.isGuest ? '(Guest)' : ''}</option>)}
            </select>
          </div>
          {selectedBucketPreview && !useCustomMessage && (<div className={styles.previewBox}><div className={styles.previewTitle}>{selectedBucketPreview.title}</div><div className={styles.previewBody}>{selectedBucketPreview.body}</div></div>)}
          <div className={styles.formGroupInline}><label><input type="checkbox" checked={useCustomMessage} onChange={e => setUseCustomMessage(e.target.checked)} /> Use custom message</label></div>
          {useCustomMessage && (<><div className={styles.formGroup}><label>Custom Title</label><input type="text" value={customTitle} onChange={e => setCustomTitle(e.target.value)} placeholder="Notification title..." className={styles.textInput} /></div><div className={styles.formGroup}><label>Custom Body</label><textarea value={customBody} onChange={e => setCustomBody(e.target.value)} placeholder="Notification body..." className={styles.textArea} rows={3} /></div></>)}
          <button onClick={handleSendPush} disabled={!selectedUser?.canSendPush || isLoading} className={styles.btnPrimary}><Icons.Send /> Send Push to Selected User</button>
          <hr className={styles.divider} />
          <h3><Icons.Mail /> Send Test Email</h3>
          <div className={styles.formGroup}><label>Email Address</label><input type="email" value={emailAddress} onChange={e => setEmailAddress(e.target.value)} placeholder={selectedUser?.email || "email@example.com"} className={styles.textInput} /></div>
          <div className={styles.formGroup}><label>Template</label><select value={emailTemplate} onChange={e => setEmailTemplate(e.target.value)} className={styles.selectInput}><option value="welcome">Welcome Email</option><option value="reminder">Reminder Email</option><option value="milestone">Milestone Email</option><option value="custom">Custom Email</option></select></div>
          {emailTemplate === 'custom' && (<><div className={styles.formGroup}><label>Subject</label><input type="text" value={customSubject} onChange={e => setCustomSubject(e.target.value)} placeholder="Email subject..." className={styles.textInput} /></div><div className={styles.formGroup}><label>HTML Content</label><textarea value={customHtml} onChange={e => setCustomHtml(e.target.value)} placeholder="<p>Email content...</p>" className={styles.textArea} rows={4} /></div></>)}
          <button onClick={handleSendEmail} disabled={(!emailAddress && !selectedUser?.email) || isLoading} className={styles.btnPrimary}><Icons.Mail /> Send Test Email</button>
        </div>

        {/* Right Column - Results & System */}
        <div className={styles.testingSection}>
          <h3><Icons.Terminal /> System & Results</h3>
          <div className={styles.systemActions}><button onClick={handleCheckHealth} disabled={isLoading} className={styles.btnSmall}><Icons.Activity /> Check Health</button><button onClick={handleTestFCM} disabled={isLoading} className={styles.btnSmall}><Icons.Zap /> Test FCM</button></div>
          {systemHealth && (<div className={`${styles.healthCard} ${systemHealth.status === 'healthy' ? styles.healthGood : styles.healthBad}`}><div className={styles.healthStatus}>Status: <strong>{systemHealth.status}</strong></div><div className={styles.healthCounts}><span>Users: {systemHealth.counts?.users}</span><span>Guests: {systemHealth.counts?.guests}</span><span>Leads: {systemHealth.counts?.coldLeads}</span></div></div>)}
          <h4>Test Results</h4>
          <div className={styles.resultsLog}>
            {testResults.length === 0 ? <div className={styles.noResults}>No tests run yet</div> : testResults.map(result => (
              <div key={result.id} className={`${styles.resultItem} ${styles[`result${result.type.charAt(0).toUpperCase() + result.type.slice(1)}`]}`}>
                <div className={styles.resultHeader}><span className={styles.resultAction}>{result.action}</span><span className={styles.resultTime}>{new Date(result.timestamp).toLocaleTimeString()}</span></div>
                <div className={styles.resultMessage}>{result.message || result.error}</div>
              </div>
            ))}
          </div>
          {testResults.length > 0 && <button onClick={() => setTestResults([])} className={styles.btnSmall}>Clear Results</button>}
        </div>
      </div>
    </div>
  );
};

// ============================================
// USER DETAIL MODAL
// ============================================

const UserDetailModal = ({ userId, onClose, onUpdate }) => {
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(false);
  const [editValues, setEditValues] = useState({});
  const [activeTab, setActiveTab] = useState('info');
  const functions = getFunctions(app);

  useEffect(() => {
    const fetchDetail = async () => {
      try {
        const getDetail = httpsCallable(functions, 'getAdminUserDetail');
        const result = await getDetail({ userId });
        setDetail(result.data);
        setEditValues({ userRole: result.data.user.userRole || result.data.user.user_role || 'standard', streak: result.data.user.streak || 0, showAds: result.data.user.showAds ?? result.data.user.show_ads ?? true, hasQuit: result.data.user.hasQuit || false });
      } catch (err) { console.error('Error fetching user detail:', err); }
      finally { setLoading(false); }
    };
    fetchDetail();
  }, [userId, functions]);

  const handleSave = async () => {
    try {
      const updateUser = httpsCallable(functions, 'adminUpdateUser');
      await updateUser({ userId, updates: { user_role: editValues.userRole, userRole: editValues.userRole, streak: parseInt(editValues.streak) || 0, show_ads: editValues.showAds, showAds: editValues.showAds, hasQuit: editValues.hasQuit } });
      setEditing(false);
      onUpdate && onUpdate();
    } catch (err) { console.error('Error updating user:', err); alert('Failed to update user: ' + err.message); }
  };

  if (loading) return <div className={styles.modalOverlay} onClick={onClose}><div className={styles.modalContent} onClick={e => e.stopPropagation()}><div className={styles.modalLoading}>Loading user details...</div></div></div>;
  if (!detail) return <div className={styles.modalOverlay} onClick={onClose}><div className={styles.modalContent} onClick={e => e.stopPropagation()}><div className={styles.modalError}>Failed to load user</div><button onClick={onClose} className={styles.btn}>Close</button></div></div>;

  const { user, dailyStats, emailState, recentPuffs, devices } = detail;
  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={e => e.stopPropagation()}>
        <button className={styles.modalClose} onClick={onClose}>×</button>
        <div className={styles.modalHeader}><h2>{user.email || user.username || 'Unknown User'}</h2><span className={styles.userIdFull}>{user.userId}</span><div className={styles.userBadges}>{user.hasQuit && <span className={styles.badgeQuit}>Quit</span>}{(user.showAds === false || user.show_ads === false) && <span className={styles.badgePremium}>Premium</span>}</div></div>
        <div className={styles.modalTabs}>{['info', 'activity', 'email', 'devices'].map(tab => <button key={tab} className={`${styles.modalTab} ${activeTab === tab ? styles.modalTabActive : ''}`} onClick={() => setActiveTab(tab)}>{tab.charAt(0).toUpperCase() + tab.slice(1)}</button>)}</div>
        <div className={styles.modalBody}>
          {activeTab === 'info' && (
            <div className={styles.tabPane}>
              <div className={styles.sectionHeader}><h3>User Information</h3>{!editing && <button className={styles.btnSmall} onClick={() => setEditing(true)}>Edit</button>}</div>
              {editing ? (
                <div className={styles.editForm}>
                  <div className={styles.formGroup}><label>Role</label><select value={editValues.userRole} onChange={e => setEditValues({...editValues, userRole: e.target.value})}><option value="standard">Standard</option><option value="admin">Admin</option><option value="tester">Tester</option></select></div>
                  <div className={styles.formGroup}><label>Streak</label><input type="number" value={editValues.streak} onChange={e => setEditValues({...editValues, streak: e.target.value})} /></div>
                  <div className={styles.formGroupInline}><label><input type="checkbox" checked={!editValues.showAds} onChange={e => setEditValues({...editValues, showAds: !e.target.checked})} /> Premium (No Ads)</label></div>
                  <div className={styles.formGroupInline}><label><input type="checkbox" checked={editValues.hasQuit} onChange={e => setEditValues({...editValues, hasQuit: e.target.checked})} /> Has Quit</label></div>
                  <div className={styles.formActions}><button onClick={handleSave} className={styles.btnPrimary}>Save</button><button onClick={() => setEditing(false)} className={styles.btnSecondary}>Cancel</button></div>
                </div>
              ) : (
                <div className={styles.infoGrid}>
                  <InfoItem label="Email" value={user.email || '—'} /><InfoItem label="Username" value={user.username || '—'} /><InfoItem label="First Name" value={user.firstName || user.first_name || '—'} /><InfoItem label="Role" value={user.userRole || user.user_role || 'standard'} /><InfoItem label="Premium" value={user.showAds === false ? 'Yes' : 'No'} /><InfoItem label="Has Quit" value={user.hasQuit ? 'Yes' : 'No'} /><InfoItem label="Streak" value={`${user.streak || 0} days`} /><InfoItem label="Platform" value={user.platform || user.devicePlatform || '—'} /><InfoItem label="Last Active" value={user.lastUpdatedMs ? formatTimeAgo(user.lastUpdatedMs) : 'Never'} /><InfoItem label="Created" value={user.createdAt ? new Date(user.createdAt).toLocaleDateString() : '—'} />
                </div>
              )}
            </div>
          )}
          {activeTab === 'activity' && <div className={styles.tabPane}><h3>Activity (Last 60 Days)</h3>{dailyStats && dailyStats.length > 0 ? (<><div className={styles.chartContainer}><MiniLineChart data={dailyStats} dataKey="puffCount" height={120} /></div><div className={styles.activitySummary}><div className={styles.summaryItem}><span className={styles.summaryLabel}>Total Puffs</span><span className={styles.summaryValue}>{dailyStats.reduce((s, d) => s + d.puffCount, 0)}</span></div><div className={styles.summaryItem}><span className={styles.summaryLabel}>Total Duration</span><span className={styles.summaryValue}>{Math.round(dailyStats.reduce((s, d) => s + d.puffDurationMs, 0) / 60000)} min</span></div></div></>) : <div className={styles.noData}>No activity data</div>}</div>}
          {activeTab === 'email' && <div className={styles.tabPane}><h3>Email Campaign Status</h3>{emailState ? <div className={styles.infoGrid}><InfoItem label="Current Sequence" value={emailState.currentSequence || 0} /><InfoItem label="Total Sent" value={emailState.totalSent || 0} /><InfoItem label="Last Sent" value={emailState.lastSentMs ? formatTimeAgo(emailState.lastSentMs) : 'Never'} /></div> : <div className={styles.noData}>No email state found</div>}</div>}
          {activeTab === 'devices' && <div className={styles.tabPane}><h3>Registered Devices</h3>{devices && devices.length > 0 ? <div className={styles.devicesList}>{devices.map(device => <div key={device.id} className={styles.deviceItem}><span className={styles.deviceId}>{device.id.slice(0, 12)}...</span><span className={styles.deviceToken}>Token: {device.token?.slice(0, 20)}...</span></div>)}</div> : <div className={styles.noData}>No devices registered</div>}</div>}
        </div>
      </div>
    </div>
  );
};

// ============================================
// MAIN ADMIN COMPONENT
// ============================================

const AdminAccount = () => {
  const navigate = useNavigate();
  const functions = getFunctions(app);
  const [activeTab, setActiveTab] = useState('overview');
  const [stats, setStats] = useState(null);
  const [users, setUsers] = useState([]);
  const [coldLeads, setColdLeads] = useState([]);
  const [orders, setOrders] = useState([]);
  const [emailCampaigns, setEmailCampaigns] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [lastRefresh, setLastRefresh] = useState(null);
  const [pushStats, setPushStats] = useState(null);
  const [funnelData, setFunnelData] = useState(null);
  const [retentionData, setRetentionData] = useState(null);
  const [ltvData, setLtvData] = useState(null);
  const [activityFeed, setActivityFeed] = useState(null);
  const [activityLoading, setActivityLoading] = useState(false);
  const [comparisonData, setComparisonData] = useState(null);
  const [userFilter, setUserFilter] = useState(null);
  const [userSearch, setUserSearch] = useState('');
  const [hasMoreUsers, setHasMoreUsers] = useState(false);
  const [lastUserId, setLastUserId] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState(null);

  // Study management state
  const [studyParticipants, setStudyParticipants] = useState([]);
  const [studyCohorts, setStudyCohorts] = useState([]);
  const [studyStats, setStudyStats] = useState(null);
  const [studyLoading, setStudyLoading] = useState(false);
  const [studyCohortFilter, setStudyCohortFilter] = useState(null);
  const [studySubTab, setStudySubTab] = useState('participants');
  const [scoringData, setScoringData] = useState(null);
  const [scoringLoading, setScoringLoading] = useState(false);
  const [expandedScoringRow, setExpandedScoringRow] = useState(null);
  const [newCohortName, setNewCohortName] = useState('');
  const [newCohortDuration, setNewCohortDuration] = useState(56);

  // Study signup management state
  const [studySignups, setStudySignups] = useState([]);
  const [signupLinkLoading, setSignupLinkLoading] = useState(null);
  const [copiedCohortId, setCopiedCohortId] = useState(null);
  const [deleteModal, setDeleteModal] = useState({ open: false, participant: null, type: null });
  const [deleteLoading, setDeleteLoading] = useState(false);

  // Usage analytics state
  const [usageSubTab, setUsageSubTab] = useState('aggregate');
  const [usageSelectedUserId, setUsageSelectedUserId] = useState(null);
  const [usageUserSearch, setUsageUserSearch] = useState('');
  const [usageUserData, setUsageUserData] = useState(null);
  const [usageUserLoading, setUsageUserLoading] = useState(false);
  const [usageUserRange, setUsageUserRange] = useState('week');
  const [usageAggregateData, setUsageAggregateData] = useState(null);
  const [usageAggregateLoading, setUsageAggregateLoading] = useState(false);
  const [usageFilters, setUsageFilters] = useState({ cohortId: null, signupDateFrom: null, signupDateTo: null, platform: null, premium: null, engagement: null, hasQuit: null });
  const [usagePeriod, setUsagePeriod] = useState(30);

  const fetchStats = useCallback(async () => { try { const getStats = httpsCallable(functions, 'getAdminStats'); const result = await getStats(); setStats(result.data); setLastRefresh(Date.now()); } catch (err) { console.error('Error fetching stats:', err); setError('Failed to load dashboard stats: ' + err.message); } }, [functions]);
  const fetchPushStats = useCallback(async () => { try { const getStats = httpsCallable(functions, 'getAdminPushStats'); const result = await getStats({ days: 30 }); setPushStats(result.data); } catch (err) { console.error('Error fetching push stats:', err); } }, [functions]);
  const fetchUsers = useCallback(async (startAfter = null) => { try { const getUsers = httpsCallable(functions, 'getAdminUsers'); const result = await getUsers({ limit: 50, startAfter, filter: userFilter }); if (startAfter) setUsers(prev => [...prev, ...result.data.users]); else setUsers(result.data.users); setHasMoreUsers(result.data.hasMore); setLastUserId(result.data.lastDocId); } catch (err) { console.error('Error fetching users:', err); } }, [functions, userFilter]);
  const fetchEmailCampaigns = useCallback(async () => { try { const getCampaigns = httpsCallable(functions, 'getAdminEmailCampaigns'); const result = await getCampaigns(); setEmailCampaigns(result.data); } catch (err) { console.error('Error fetching email campaigns:', err); } }, [functions]);
  const fetchColdLeads = useCallback(async () => { try { const getLeads = httpsCallable(functions, 'getAdminColdLeads'); const result = await getLeads({ limit: 100 }); setColdLeads(result.data.leads); } catch (err) { console.error('Error fetching cold leads:', err); } }, [functions]);
  const fetchOrders = useCallback(async () => { try { const getOrders = httpsCallable(functions, 'getAdminOrders'); const result = await getOrders({ limit: 100 }); setOrders(result.data.orders); } catch (err) { console.error('Error fetching orders:', err); } }, [functions]);
  const fetchFunnel = useCallback(async () => { try { const getFunnel = httpsCallable(functions, 'getConversionFunnel'); const result = await getFunnel({ days: 30 }); setFunnelData(result.data); } catch (err) { console.error('Error fetching funnel:', err); } }, [functions]);
  const fetchRetention = useCallback(async () => { try { const getRetention = httpsCallable(functions, 'getRetentionCohorts'); const result = await getRetention({ weeks: 8 }); setRetentionData(result.data); } catch (err) { console.error('Error fetching retention:', err); } }, [functions]);
  const fetchLTV = useCallback(async () => { try { const getLTV = httpsCallable(functions, 'getUserLTV'); const result = await getLTV(); setLtvData(result.data); } catch (err) { console.error('Error fetching LTV:', err); } }, [functions]);
  const fetchActivityFeed = useCallback(async () => { setActivityLoading(true); try { const getFeed = httpsCallable(functions, 'getActivityFeed'); const result = await getFeed({ limit: 50, hours: 24 }); setActivityFeed(result.data.activities); } catch (err) { console.error('Error fetching activity feed:', err); } finally { setActivityLoading(false); } }, [functions]);
  const fetchComparison = useCallback(async () => { try { const getComparison = httpsCallable(functions, 'getPeriodComparison'); const result = await getComparison({ days: 7 }); setComparisonData(result.data.comparisons); } catch (err) { console.error('Error fetching comparison:', err); } }, [functions]);
  const triggerSnapshot = async () => { try { const trigger = httpsCallable(functions, 'triggerMetaSnapshot'); await trigger(); alert('Snapshot triggered successfully!'); fetchStats(); } catch (err) { alert('Failed to trigger snapshot: ' + err.message); } };
  const refreshAll = async () => { setLoading(true); await Promise.all([fetchStats(), fetchUsers(), fetchEmailCampaigns(), fetchActivityFeed(), fetchComparison()]); setLoading(false); };

  // Usage analytics fetch functions
  const fetchUsageUserData = useCallback(async (userId, range = 'week') => {
    setUsageUserLoading(true);
    try {
      const fn = httpsCallable(functions, 'getAdminUserUsage');
      const result = await fn({ userId, range });
      setUsageUserData(result.data);
    } catch (err) { console.error('Error fetching user usage:', err); }
    finally { setUsageUserLoading(false); }
  }, [functions]);

  const fetchUsageAggregate = useCallback(async () => {
    setUsageAggregateLoading(true);
    try {
      const fn = httpsCallable(functions, 'getAdminAggregateUsage');
      const result = await fn({ filters: usageFilters, period: usagePeriod });
      setUsageAggregateData(result.data);
    } catch (err) { console.error('Error fetching aggregate usage:', err); }
    finally { setUsageAggregateLoading(false); }
  }, [functions, usageFilters, usagePeriod]);

  // Study management functions
  const fetchStudyParticipants = useCallback(async () => {
    setStudyLoading(true);
    try {
      const getStudyData = httpsCallable(functions, 'getAdminStudyParticipants');
      const result = await getStudyData({ cohort: studyCohortFilter });
      setStudyParticipants(result.data.participants || []);
      setStudyCohorts(result.data.cohorts || []);
      setStudyStats(result.data.stats || null);
    } catch (err) {
      console.error('Error fetching study participants:', err);
    } finally {
      setStudyLoading(false);
    }
  }, [functions, studyCohortFilter]);

  const fetchStudyScoring = useCallback(async () => {
    setScoringLoading(true);
    try {
      const getScoring = httpsCallable(functions, 'getAdminStudyScoring');
      const result = await getScoring({ cohortId: studyCohortFilter });
      setScoringData(result.data);
    } catch (err) {
      console.error('Error fetching study scoring:', err);
    } finally {
      setScoringLoading(false);
    }
  }, [functions, studyCohortFilter]);

  const startStudy = async (participantId) => {
    try {
      const startStudyFn = httpsCallable(functions, 'adminStartStudy');
      await startStudyFn({ participantId });
      fetchStudyParticipants();
    } catch (err) {
      console.error('Error starting study:', err);
      alert('Failed to start study: ' + err.message);
    }
  };

  const createCohort = async () => {
    if (!newCohortName.trim()) {
      alert('Please enter a cohort name');
      return;
    }
    try {
      const createCohortFn = httpsCallable(functions, 'adminCreateStudyCohort');
      await createCohortFn({
        name: newCohortName.trim(),
        durationDays: parseInt(newCohortDuration) || 56
      });
      alert('Cohort created successfully');
      setNewCohortName('');
      fetchStudyParticipants();
    } catch (err) {
      console.error('Error creating cohort:', err);
      alert('Failed to create cohort: ' + err.message);
    }
  };

  const openDeleteModal = (participant, type = 'participant') => {
    setDeleteModal({ open: true, participant, type });
  };

  const closeDeleteModal = () => {
    setDeleteModal({ open: false, participant: null, type: null });
  };

  const handleDeleteConfirm = async ({ deleteSurveys }) => {
    const { participant, type } = deleteModal;
    if (!participant) return;

    setDeleteLoading(true);
    try {
      if (type === 'signup') {
        const deleteFn = httpsCallable(functions, 'deleteStudySignup');
        await deleteFn({ signupId: participant.id, deleteParticipant: true, deleteSurveys });
        fetchStudySignups();
      } else {
        const removeFn = httpsCallable(functions, 'adminRemoveStudyParticipant');
        await removeFn({ participantId: participant.id, deleteSurveys });
      }
      fetchStudyParticipants();
      closeDeleteModal();
    } catch (err) {
      console.error('Error removing participant:', err);
      alert('Failed to remove: ' + err.message);
    } finally {
      setDeleteLoading(false);
    }
  };

  const generateSignupLink = async (cohortId) => {
    setSignupLinkLoading(cohortId);
    try {
      const generateFn = httpsCallable(functions, 'generateStudySignupLink');
      const result = await generateFn({ cohortId });
      if (result.data.success) {
        fetchStudyParticipants(); // Refresh to get updated cohort data
        await navigator.clipboard.writeText(result.data.signupUrl);
        setCopiedCohortId(cohortId);
        setTimeout(() => setCopiedCohortId(null), 2000);
      }
    } catch (err) {
      console.error('Error generating signup link:', err);
      alert('Failed to generate signup link: ' + err.message);
    } finally {
      setSignupLinkLoading(null);
    }
  };

  const copySignupLink = async (cohort) => {
    if (!cohort.signupToken) return;
    const signupUrl = `${window.location.origin}/study/signup?token=${cohort.signupToken}`;
    await navigator.clipboard.writeText(signupUrl);
    setCopiedCohortId(cohort.id);
    setTimeout(() => setCopiedCohortId(null), 2000);
  };

  const toggleCohortSignups = async (cohortId, enabled) => {
    try {
      const toggleFn = httpsCallable(functions, 'toggleCohortSignups');
      await toggleFn({ cohortId, enabled });
      fetchStudyParticipants();
    } catch (err) {
      console.error('Error toggling signups:', err);
      alert('Failed to toggle signups: ' + err.message);
    }
  };

  const fetchStudySignups = useCallback(async () => {
    try {
      const getSignups = httpsCallable(functions, 'getStudySignups');
      const result = await getSignups({ cohortId: studyCohortFilter });
      setStudySignups(result.data.signups || []);
    } catch (err) {
      console.error('Error fetching signups:', err);
    }
  }, [functions, studyCohortFilter]);

  useEffect(() => { refreshAll(); }, []);
  useEffect(() => { if (activeTab === 'users') fetchUsers(); else if (activeTab === 'leads') fetchColdLeads(); else if (activeTab === 'orders') fetchOrders(); else if (activeTab === 'push') fetchPushStats(); else if (activeTab === 'analytics') { fetchFunnel(); fetchRetention(); fetchLTV(); } else if (activeTab === 'study') { fetchStudyParticipants(); fetchStudySignups(); } else if (activeTab === 'usage') { fetchUsageAggregate(); } }, [activeTab, userFilter, studyCohortFilter]);
  useEffect(() => { if (activeTab === 'study' && studySubTab === 'scoring') fetchStudyScoring(); }, [studySubTab, activeTab, studyCohortFilter]);

  const filteredUsers = useMemo(() => { if (!userSearch) return users; const search = userSearch.toLowerCase(); return users.filter(u => u.email?.toLowerCase().includes(search) || u.userId.toLowerCase().includes(search) || u.username?.toLowerCase().includes(search)); }, [users, userSearch]);
  const platformData = useMemo(() => { if (!stats?.platform) return []; return [{ label: 'iOS', value: stats.platform.iosUsers, color: '#007AFF' }, { label: 'Android', value: stats.platform.androidUsers, color: '#3DDC84' }, { label: 'Unknown', value: stats.platform.unknownPlatform, color: '#666' }].filter(d => d.value > 0); }, [stats]);
  const engagementData = useMemo(() => { if (!stats?.engagement) return []; return [{ label: 'High', value: stats.engagement.highEngagement, color: '#61d89e' }, { label: 'Medium', value: stats.engagement.mediumEngagement, color: '#f4b400' }, { label: 'Low', value: stats.engagement.lowEngagement, color: '#e08e8e' }, { label: 'Churned', value: stats.engagement.churned, color: '#666' }]; }, [stats]);
  const revenueChartData = useMemo(() => { if (!stats?.revenue?.revenueByDay) return []; return Object.entries(stats.revenue.revenueByDay).map(([date, value]) => ({ date, value })).sort((a, b) => a.date.localeCompare(b.date)); }, [stats]);

  return (
    <div className={styles.page}>
      <Header />
      <div className={styles.container}>
        <div className={styles.adminHeader}><div><h1>Admin Dashboard</h1>{lastRefresh && <span className={styles.lastRefresh}>Updated: {formatTimeAgo(lastRefresh)}</span>}</div><div className={styles.adminActions}><button onClick={triggerSnapshot} className={styles.actionBtn}><Icons.Camera /> Snapshot</button><button onClick={refreshAll} className={styles.actionBtn}><Icons.RefreshCw /> Refresh</button></div></div>
        
        <div className={styles.tabNav}>
          {['overview', 'analytics', 'users', 'leads', 'emails', 'orders', 'push', 'usage', 'study', 'testing'].map(tab => (
            <button key={tab} className={`${styles.tabBtn} ${activeTab === tab ? styles.tabBtnActive : ''} ${tab === 'testing' ? styles.tabBtnTest : ''} ${tab === 'study' ? styles.tabBtnStudy : ''}`} onClick={() => setActiveTab(tab)}>
              {tab === 'testing' ? '🧪 Testing' : tab === 'study' ? '📋 Study' : tab === 'usage' ? '📊 Usage' : tab.charAt(0).toUpperCase() + tab.slice(1)}
            </button>
          ))}
        </div>
        
        {loading && <div className={styles.loadingState}>Loading dashboard...</div>}
        {error && <div className={styles.errorState}>{error}</div>}

        {/* OVERVIEW TAB */}
        {activeTab === 'overview' && stats && (
          <div className={styles.tabContent}>
            <div className={styles.statsGrid}><StatCard label="Total Users" value={formatNumber(stats.overview.totalUsers)} subtitle={`+${stats.overview.newToday} today`} icon={Icons.Users} color="blue" comparison={comparisonData?.newUsers} /><StatCard label="Active Today" value={formatNumber(stats.overview.activeToday)} subtitle={`${Math.round(stats.overview.activeToday / stats.overview.totalUsers * 100)}% of users`} icon={Icons.Activity} color="green" comparison={comparisonData?.activeUsers} /><StatCard label="Quit Users" value={formatNumber(stats.overview.quitUsers)} subtitle={`${Math.round(stats.overview.quitUsers / stats.overview.totalUsers * 100)}% quit rate`} icon={Icons.Award} color="purple" /><StatCard label="Premium" value={formatNumber(stats.overview.premiumUsers)} subtitle={`${Math.round(stats.overview.premiumUsers / stats.overview.totalUsers * 100)}% conversion`} icon={Icons.DollarSign} color="gold" /></div>
            <div className={styles.statsGrid}><StatCard label="Avg Streak" value={`${stats.overview.avgStreak} days`} icon={Icons.TrendingUp} /><StatCard label="Guest Devices" value={formatNumber(stats.overview.guestDevices)} icon={Icons.Smartphone} color="coral" /><StatCard label="Cold Leads" value={formatNumber(stats.overview.coldLeads)} subtitle="Landing page signups" icon={Icons.Mail} color="blue" /><StatCard label="Crashes (24h)" value={stats.crashes?.last24h || 0} subtitle={`${stats.crashes?.last7d || 0} this week`} icon={Icons.AlertTriangle} color={stats.crashes?.last24h > 5 ? 'coral' : 'green'} /></div>
            <div className={styles.chartsRow}><div className={styles.chartCard} style={{ flex: 2 }}><h3>30-Day User Trends</h3>{stats.trends && stats.trends.length > 0 ? <div className={styles.multiChart}><div className={styles.chartWithLabel}><span>Total Users</span><MiniLineChart data={stats.trends} dataKey="totalUsers" height={80} /></div><div className={styles.chartWithLabel}><span>Active Today</span><MiniLineChart data={stats.trends} dataKey="activeToday" color="#3b82f6" height={80} /></div><div className={styles.chartWithLabel}><span>Quit Users</span><MiniLineChart data={stats.trends} dataKey="quitUsers" color="#a855f7" height={80} /></div></div> : <div className={styles.noData}>No trend data</div>}</div><div className={styles.chartCard} style={{ flex: 1 }}><ActivityFeed activities={activityFeed} onRefresh={fetchActivityFeed} loading={activityLoading} /></div></div>
            <div className={styles.chartsRow}><div className={styles.chartCard}><h3>Platform Distribution</h3><div className={styles.donutContainer}><DonutChart data={platformData} size={140} /><div className={styles.legendList}>{platformData.map(item => <div key={item.label} className={styles.legendItem}><span className={styles.legendDot} style={{ backgroundColor: item.color }} /><span>{item.label}: {item.value}</span></div>)}</div></div></div><div className={styles.chartCard}><h3>Engagement Levels</h3><div className={styles.donutContainer}><DonutChart data={engagementData} size={140} /><div className={styles.legendList}>{engagementData.map(item => <div key={item.label} className={styles.legendItem}><span className={styles.legendDot} style={{ backgroundColor: item.color }} /><span>{item.label}: {item.value}</span></div>)}</div></div></div></div>
            <div className={styles.summaryRow}><div className={styles.summaryCard}><h3>Revenue Overview</h3><div className={styles.revenueStats}><div className={styles.revenueStat}><span>Last 30 Days</span><span className={styles.revenueValue}>{formatCurrency(stats.revenue?.revenue30d || 0)}{comparisonData?.revenue && <ComparisonBadge current={comparisonData.revenue.current} previous={comparisonData.revenue.previous} />}</span></div><div className={styles.revenueStat}><span>Last 7 Days</span><span className={styles.revenueValue}>{formatCurrency(stats.revenue?.revenue7d || 0)}</span></div><div className={styles.revenueStat}><span>Total Orders</span><span className={styles.revenueValue}>{stats.revenue?.orderCount30d || 0}</span></div><div className={styles.revenueStat}><span>Avg Order</span><span className={styles.revenueValue}>{formatCurrency(stats.revenue?.avgOrderValue || 0)}</span></div></div>{revenueChartData.length > 0 && <MiniLineChart data={revenueChartData} dataKey="value" color="#f4b400" height={80} showAxes />}</div><div className={styles.summaryCard}><h3>Email Campaigns</h3><div className={styles.emailStats}><div className={styles.emailStatRow}><span>Cold Lead Emails Sent</span><span>{stats.emailCampaigns?.coldLead?.totalSent || 0}</span></div><div className={styles.emailStatRow}><span>App User Emails Sent</span><span>{stats.emailCampaigns?.appUser?.totalSent || 0}</span></div><div className={styles.emailStatRow}><span>Retry Queue Pending</span><span>{stats.emailCampaigns?.retryQueue?.pending || 0}</span></div><div className={styles.emailStatRow}><span>Failed (permanent)</span><span className={stats.emailCampaigns?.retryQueue?.failed > 0 ? styles.textDanger : ''}>{stats.emailCampaigns?.retryQueue?.failed || 0}</span></div></div></div><div className={styles.summaryCard}><h3>Leads by Interest</h3><HorizontalBarChart data={stats.coldLeads?.byInterest || {}} /></div></div>
          </div>
        )}

        {/* ANALYTICS TAB */}
        {activeTab === 'analytics' && (
          <div className={styles.tabContent}>
            <div className={styles.analyticsGrid}><div className={styles.analyticsCard}><h3><Icons.Filter /> Conversion Funnel (30d)</h3>{funnelData ? <FunnelChart data={funnelData.funnel} outcomes={funnelData.outcomes} /> : <div className={styles.loadingState}>Loading funnel data...</div>}</div><div className={styles.analyticsCard}><h3><Icons.DollarSign /> Lifetime Value Analysis</h3><LTVCard data={ltvData} /></div></div>
            <div className={styles.analyticsCard} style={{ marginTop: '20px' }}><h3><Icons.BarChart /> Retention Cohorts by Week</h3>{retentionData ? <RetentionTable cohorts={retentionData.cohorts} averages={retentionData.averages} /> : <div className={styles.loadingState}>Loading retention data...</div>}</div>
          </div>
        )}

        {/* USERS TAB */}
        {activeTab === 'users' && (
          <div className={styles.tabContent}>
            <div className={styles.toolbar}><input type="text" placeholder="Search by email, username, or ID..." value={userSearch} onChange={e => setUserSearch(e.target.value)} className={styles.searchInput} /><div className={styles.filterGroup}>{['all', 'active', 'quit', 'premium', 'churned'].map(filter => <button key={filter} className={`${styles.filterBtn} ${(userFilter === null && filter === 'all') || userFilter === filter ? styles.filterBtnActive : ''}`} onClick={() => setUserFilter(filter === 'all' ? null : filter)}>{filter.charAt(0).toUpperCase() + filter.slice(1)}</button>)}</div><button onClick={() => exportToCSV(filteredUsers, 'users-export')} className={styles.actionBtn}><Icons.Download /> Export CSV</button></div>
            <DataTable columns={[{ key: 'email', label: 'User', render: (val, row) => <div className={styles.userCell}><span className={styles.userEmail}>{val || row.username || 'No email'}</span><span className={styles.userId}>{row.userId.slice(0, 8)}...</span></div> }, { key: 'userRole', label: 'Role', width: '80px', render: val => <span className={styles.badge}>{val || 'standard'}</span> }, { key: 'status', label: 'Status', width: '120px', render: (_, row) => <div className={styles.statusBadges}>{row.hasQuit && <span className={styles.badgeQuit}>Quit</span>}{!row.showAds && <span className={styles.badgePremium}>Pro</span>}</div> }, { key: 'streak', label: 'Streak', width: '80px', render: val => `${val || 0}d` }, { key: 'last7Days', label: '7-Day Activity', render: val => val ? `${val.puffs} puffs / ${val.durationMins}m` : '—' }, { key: 'lastUpdatedMs', label: 'Last Active', width: '100px', render: val => val ? formatTimeAgo(val) : 'Never' }]} data={filteredUsers.map(u => ({ ...u, id: u.userId }))} onRowClick={row => setSelectedUserId(row.userId)} selectedId={selectedUserId} emptyMessage="No users found" />
            {hasMoreUsers && <button className={styles.loadMoreBtn} onClick={() => fetchUsers(lastUserId)}>Load More</button>}
          </div>
        )}

        {/* LEADS TAB */}
        {activeTab === 'leads' && (
          <div className={styles.tabContent}>
            <div className={styles.toolbar}><button onClick={() => exportToCSV(coldLeads, 'leads-export')} className={styles.actionBtn}><Icons.Download /> Export CSV</button></div>
            <DataTable columns={[{ key: 'email', label: 'Email' }, { key: 'name', label: 'Name', render: val => val || '—' }, { key: 'interest', label: 'Interest', render: val => <span className={styles.badge}>{val || 'unknown'}</span> }, { key: 'source', label: 'Source', render: val => val || 'direct' }, { key: 'emailState', label: 'Email Status', render: val => val ? `Seq ${val.currentSequence} / ${val.totalSent} sent` : 'No emails' }, { key: 'unsubscribed', label: 'Subscribed', width: '80px', render: val => val ? <Icons.X /> : <Icons.Check /> }, { key: 'createdAt', label: 'Signed Up', render: val => val ? new Date(val).toLocaleDateString() : '—' }]} data={coldLeads.map(l => ({ ...l, id: l.leadId }))} emptyMessage="No cold leads found" />
          </div>
        )}

        {/* EMAILS TAB */}
        {activeTab === 'emails' && emailCampaigns && (
          <div className={styles.tabContent}>
            <div className={styles.emailGrid}>
              <div className={styles.pipelineCard}><h3>Cold Lead Pipeline</h3><div className={styles.pipelineStats}><div className={styles.pipelineStat}><span className={styles.pipelineValue}>{emailCampaigns.coldLead.total}</span><span>Total Leads</span></div><div className={styles.pipelineStat}><span className={styles.pipelineValue}>{emailCampaigns.coldLead.totalSent}</span><span>Emails Sent</span></div></div><h4>Sequence Distribution</h4><HorizontalBarChart data={emailCampaigns.coldLead.bySequence} maxValue={emailCampaigns.coldLead.total} /></div>
              <div className={styles.pipelineCard}><h3>App User Pipeline</h3><div className={styles.pipelineStats}><div className={styles.pipelineStat}><span className={styles.pipelineValue}>{emailCampaigns.appUser.total}</span><span>With Email State</span></div><div className={styles.pipelineStat}><span className={styles.pipelineValue}>{emailCampaigns.appUser.totalSent}</span><span>Emails Sent</span></div></div><h4>Sequence Distribution</h4><HorizontalBarChart data={emailCampaigns.appUser.bySequence} maxValue={emailCampaigns.appUser.total} /></div>
              <div className={styles.pipelineCard}><h3>Behavior Buckets</h3><HorizontalBarChart data={emailCampaigns.appUser.byBucket} /></div>
              <div className={styles.pipelineCard}><h3>Retry Queue</h3><div className={styles.retryStats}><div className={`${styles.retryStat} ${emailCampaigns.retryQueue.pending > 0 ? styles.retryWarning : ''}`}><span className={styles.retryValue}>{emailCampaigns.retryQueue.pending}</span><span>Pending</span></div><div className={`${styles.retryStat} ${emailCampaigns.retryQueue.failed > 0 ? styles.retryDanger : ''}`}><span className={styles.retryValue}>{emailCampaigns.retryQueue.failed}</span><span>Failed</span></div></div></div>
            </div>
          </div>
        )}

        {/* ORDERS TAB */}
        {activeTab === 'orders' && (
          <div className={styles.tabContent}>
            {stats?.revenue && <div className={styles.ordersSummary}><StatCard label="Total Revenue" value={formatCurrency(stats.revenue.totalRevenue)} color="gold" /><StatCard label="30-Day Revenue" value={formatCurrency(stats.revenue.revenue30d)} color="green" /><StatCard label="Orders (30d)" value={stats.revenue.orderCount30d} color="blue" /><StatCard label="Pre-orders" value={stats.revenue.preorderCount} color="purple" /></div>}
            <div className={styles.toolbar}><button onClick={() => exportToCSV(orders, 'orders-export')} className={styles.actionBtn}><Icons.Download /> Export CSV</button></div>
            <DataTable columns={[{ key: 'orderId', label: 'Order ID', render: val => val?.slice(-8)?.toUpperCase() }, { key: 'email', label: 'Email' }, { key: 'amount', label: 'Amount', render: val => formatCurrency(val || 0) }, { key: 'payment_status', label: 'Status', render: val => <span className={`${styles.badge} ${val === 'paid' ? styles.badgePaid : ''}`}>{val}</span> }, { key: 'isPreorder', label: 'Type', render: val => val ? 'Pre-order' : 'Order' }, { key: 'timestamp', label: 'Date', render: val => val ? new Date(val).toLocaleDateString() : '—' }]} data={orders.map(o => ({ ...o, id: o.orderId }))} emptyMessage="No orders found" />
          </div>
        )}

        {/* PUSH TAB */}
        {activeTab === 'push' && (
          <div className={styles.tabContent}>
            {!pushStats ? <div className={styles.loadingState}>Loading push notification stats...</div> : (
              <>
                <div className={styles.statsGrid}><StatCard label="Registered Sent (30d)" value={formatNumber(pushStats.summary?.registered?.sent || 0)} subtitle={`${pushStats.summary?.registered?.successRate || 0}% success rate`} icon={Icons.Bell} color="green" /><StatCard label="Guest Sent (30d)" value={formatNumber(pushStats.summary?.guest?.sent || 0)} subtitle={`${pushStats.summary?.guest?.successRate || 0}% success rate`} icon={Icons.Smartphone} color="blue" /><StatCard label="Total Failed (30d)" value={formatNumber((pushStats.summary?.registered?.failed || 0) + (pushStats.summary?.guest?.failed || 0))} icon={Icons.AlertTriangle} color="coral" /><StatCard label="Skipped (30d)" value={formatNumber(pushStats.summary?.registered?.skipped || 0)} subtitle="Outside window, no tokens, etc." icon={Icons.X} color="gray" /></div>
                {pushStats.dailyStats && pushStats.dailyStats.length > 0 && <div className={styles.chartCard}><h3>Daily Notifications Sent</h3><MiniLineChart data={pushStats.dailyStats.map(d => ({ date: d.date, value: (d.registered?.sent || 0) + (d.anonymous?.sent || 0) }))} dataKey="value" height={120} /></div>}
                <div className={styles.chartsRow}><div className={styles.chartCard}><h3>Registered User Timezones</h3><HorizontalBarChart data={pushStats.timezones?.registered || {}} /><p className={styles.chartNote}>{pushStats.timezones?.registeredWithTz || 0} with timezone, {pushStats.timezones?.registeredWithoutTz || 0} unknown</p></div><div className={styles.chartCard}><h3>Guest Device Timezones</h3><HorizontalBarChart data={pushStats.timezones?.guest || {}} /></div><div className={styles.chartCard}><h3>Notifications by Bucket (30d)</h3><HorizontalBarChart data={pushStats.aggregatedBuckets?.sent || {}} /></div></div>
                <div className={styles.chartsRow}><div className={styles.chartCard}><h3>Skip Reasons (30d)</h3><HorizontalBarChart data={pushStats.aggregatedSkipReasons || {}} /><p className={styles.chartNote}>Send window: 5 PM - 8 PM local time</p></div>{Object.keys(pushStats.aggregatedBuckets?.failed || {}).length > 0 && <div className={styles.chartCard}><h3>Failed by Bucket (30d)</h3><HorizontalBarChart data={pushStats.aggregatedBuckets?.failed || {}} /></div>}</div>
                <div className={styles.tableCard}><h3>Daily Breakdown</h3><DataTable columns={[{ key: 'date', label: 'Date', width: '100px' }, { key: 'regSent', label: 'Registered Sent', render: (_, row) => row.registered?.sent || 0 }, { key: 'regFailed', label: 'Reg Failed', render: (_, row) => row.registered?.failed || 0 }, { key: 'guestSent', label: 'Guest Sent', render: (_, row) => row.anonymous?.sent || 0 }, { key: 'guestFailed', label: 'Guest Failed', render: (_, row) => row.anonymous?.failed || 0 }, { key: 'total', label: 'Total Sent', render: (_, row) => (row.registered?.sent || 0) + (row.anonymous?.sent || 0) }, { key: 'skipped', label: 'Skipped', render: (_, row) => row.registered?.skipped || 0 }, { key: 'bucket', label: 'Guest Bucket', render: (_, row) => row.anonymous?.bucket || '—' }]} data={[...(pushStats.dailyStats || [])].reverse().map(d => ({ ...d, id: d.date }))} emptyMessage="No push notification data yet." /></div>
              </>
            )}
          </div>
        )}

        {/* USAGE TAB */}
        {activeTab === 'usage' && (
          <div className={styles.tabContent}>
            {/* Sub-tab navigation */}
            <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1.5rem' }}>
              {['aggregate', 'individual'].map(sub => (
                <button key={sub} className={`${styles.filterBtn} ${usageSubTab === sub ? styles.filterBtnActive : ''}`} onClick={() => setUsageSubTab(sub)}>
                  {sub === 'aggregate' ? 'Aggregate Usage' : 'Individual User'}
                </button>
              ))}
            </div>

            {/* AGGREGATE SUB-TAB */}
            {usageSubTab === 'aggregate' && (
              <>
                {/* Filter bar */}
                <div className={styles.toolbar} style={{ flexWrap: 'wrap' }}>
                  <div className={styles.filterGroup}>
                    {[7, 30, 90].map(p => (
                      <button key={p} className={`${styles.filterBtn} ${usagePeriod === p ? styles.filterBtnActive : ''}`} onClick={() => setUsagePeriod(p)}>{p}d</button>
                    ))}
                  </div>
                  <div className={styles.filterGroup}>
                    {['all', 'ios', 'android'].map(p => (
                      <button key={p} className={`${styles.filterBtn} ${(usageFilters.platform === null && p === 'all') || usageFilters.platform === p ? styles.filterBtnActive : ''}`} onClick={() => setUsageFilters(f => ({...f, platform: p === 'all' ? null : p}))}>{p === 'all' ? 'All' : p === 'ios' ? 'iOS' : 'Android'}</button>
                    ))}
                  </div>
                  <div className={styles.filterGroup}>
                    {['all', 'premium', 'free'].map(p => (
                      <button key={p} className={`${styles.filterBtn} ${(usageFilters.premium === null && p === 'all') || (usageFilters.premium === true && p === 'premium') || (usageFilters.premium === false && p === 'free') ? styles.filterBtnActive : ''}`} onClick={() => setUsageFilters(f => ({...f, premium: p === 'all' ? null : p === 'premium'}))}>{p.charAt(0).toUpperCase() + p.slice(1)}</button>
                    ))}
                  </div>
                  <div className={styles.filterGroup}>
                    {['all', 'active', 'quit'].map(q => (
                      <button key={q} className={`${styles.filterBtn} ${(usageFilters.hasQuit === null && q === 'all') || (usageFilters.hasQuit === false && q === 'active') || (usageFilters.hasQuit === true && q === 'quit') ? styles.filterBtnActive : ''}`} onClick={() => setUsageFilters(f => ({...f, hasQuit: q === 'all' ? null : q === 'quit'}))}>{q.charAt(0).toUpperCase() + q.slice(1)}</button>
                    ))}
                  </div>
                  <div className={styles.filterGroup}>
                    {['all', 'high', 'medium', 'low', 'churned'].map(e => (
                      <button key={e} className={`${styles.filterBtn} ${(usageFilters.engagement === null && e === 'all') || usageFilters.engagement === e ? styles.filterBtnActive : ''}`} onClick={() => setUsageFilters(f => ({...f, engagement: e === 'all' ? null : e}))}>{e.charAt(0).toUpperCase() + e.slice(1)}</button>
                    ))}
                  </div>
                  {studyCohorts.length > 0 && (
                    <select className={styles.searchInput} style={{ maxWidth: '180px' }} value={usageFilters.cohortId || ''} onChange={e => setUsageFilters(f => ({...f, cohortId: e.target.value || null}))}>
                      <option value="">All Cohorts</option>
                      {studyCohorts.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                    </select>
                  )}
                  <input type="date" className={styles.searchInput} style={{ maxWidth: '150px' }} placeholder="Signup from" value={usageFilters.signupDateFrom ? new Date(usageFilters.signupDateFrom).toISOString().split('T')[0] : ''} onChange={e => setUsageFilters(f => ({...f, signupDateFrom: e.target.value ? new Date(e.target.value).getTime() : null}))} />
                  <input type="date" className={styles.searchInput} style={{ maxWidth: '150px' }} placeholder="Signup to" value={usageFilters.signupDateTo ? new Date(usageFilters.signupDateTo).toISOString().split('T')[0] : ''} onChange={e => setUsageFilters(f => ({...f, signupDateTo: e.target.value ? new Date(e.target.value).getTime() : null}))} />
                  <button onClick={fetchUsageAggregate} className={styles.actionBtn}><Icons.RefreshCw /> Apply</button>
                </div>

                {usageAggregateLoading ? <div className={styles.loadingState}>Loading usage analytics...</div> : usageAggregateData && (
                  <>
                    {usageAggregateData.capped && <div className={styles.errorState} style={{ background: '#332800', borderColor: '#665200' }}>Showing data for 200 of {usageAggregateData.summary.userCount} matching users (capped for performance)</div>}

                    {/* Summary stat cards */}
                    <div className={styles.statsGrid}>
                      <StatCard label="Users Analyzed" value={usageAggregateData.summary.usersWithData} subtitle={`of ${usageAggregateData.summary.userCount} matching`} icon={Icons.Users} color="blue" comparison={usageAggregateData.trends?.usersWithData} />
                      <StatCard label="Avg Puffs/Day" value={usageAggregateData.averages.avgPuffsPerUserPerDay} icon={Icons.Activity} color="green" comparison={usageAggregateData.trends?.avgPuffsPerUserPerDay} />
                      <StatCard label="Avg Duration/Day" value={`${Math.round(usageAggregateData.averages.avgDurationPerUserPerDayMs / 60000)}m`} icon={Icons.TrendingUp} color="purple" comparison={usageAggregateData.trends?.avgDurationPerUserPerDayMs} />
                      <StatCard label="Avg Puff Duration" value={`${(usageAggregateData.averages.avgPuffDurationMs / 1000).toFixed(1)}s`} icon={Icons.Zap} color="gold" comparison={usageAggregateData.trends?.avgPuffDurationMs} />
                      <StatCard label="Avg Cluster Wait" value={`${Math.round(usageAggregateData.averages.avgClusterWaitMs / 60000)}m`} icon={Icons.Award} color="coral" comparison={usageAggregateData.trends?.avgClusterWaitMs} />
                      <StatCard label="Avg Clusters/Day" value={usageAggregateData.averages.avgClustersPerUserPerDay} icon={Icons.BarChart} color="blue" comparison={usageAggregateData.trends?.avgClustersPerUserPerDay} />
                    </div>

                    {/* Daily aggregate bar chart + Engagement donut */}
                    <div className={styles.chartsRow}>
                      <div className={styles.chartCard} style={{ flex: 2 }}>
                        <h3>Daily Aggregate Puffs ({usagePeriod}d)</h3>
                        <VerticalBarChart data={usageAggregateData.dailyTotals} dataKey="totalPuffs" labelKey="dayEpochMs" timeMode="day" height={220} />
                      </div>
                      <div className={styles.chartCard} style={{ flex: 1 }}>
                        <h3>Engagement Breakdown</h3>
                        <div className={styles.donutContainer}>
                          <DonutChart data={[
                            { label: 'High', value: usageAggregateData.engagementBreakdown.high, color: '#61d89e' },
                            { label: 'Medium', value: usageAggregateData.engagementBreakdown.medium, color: '#f4b400' },
                            { label: 'Low', value: usageAggregateData.engagementBreakdown.low, color: '#e08e8e' },
                            { label: 'Churned', value: usageAggregateData.engagementBreakdown.churned, color: '#666' },
                          ].filter(d => d.value > 0)} size={140} />
                          <div className={styles.legendList}>
                            {[{ l: 'High (5+d/wk)', v: usageAggregateData.engagementBreakdown.high, c: '#61d89e' },
                              { l: 'Medium (2-4d)', v: usageAggregateData.engagementBreakdown.medium, c: '#f4b400' },
                              { l: 'Low (1d)', v: usageAggregateData.engagementBreakdown.low, c: '#e08e8e' },
                              { l: 'Churned (0d)', v: usageAggregateData.engagementBreakdown.churned, c: '#666' }]
                              .map(item => <div key={item.l} className={styles.legendItem}><span className={styles.legendDot} style={{ backgroundColor: item.c }} /><span>{item.l}: {item.v}</span></div>)}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Distribution charts */}
                    <div className={styles.chartsRow}>
                      <div className={styles.chartCard}>
                        <h3>Avg Puffs/Day Distribution</h3>
                        <HorizontalBarChart data={usageAggregateData.distributions.puffsPerDay} />
                      </div>
                      <div className={styles.chartCard}>
                        <h3>Avg Duration/Day Distribution</h3>
                        <HorizontalBarChart data={usageAggregateData.distributions.durationPerDay} />
                      </div>
                      <div className={styles.chartCard}>
                        <h3>Streak Distribution</h3>
                        <HorizontalBarChart data={usageAggregateData.streakDistribution} />
                      </div>
                    </div>

                    {/* Goal adherence */}
                    <div className={styles.chartsRow}>
                      <div className={styles.chartCard}>
                        <h3>Goal Adherence (sampled)</h3>
                        <div className={styles.donutContainer}>
                          <DonutChart data={[
                            { label: 'Within Goal', value: Math.round((1 - usageAggregateData.goalAdherence.exceededDailyTotalRate) * 100), color: '#61d89e' },
                            { label: 'Exceeded', value: Math.round(usageAggregateData.goalAdherence.exceededDailyTotalRate * 100), color: '#e08e8e' },
                          ].filter(d => d.value > 0)} size={140} />
                          <div className={styles.legendList}>
                            <div className={styles.legendItem}><span className={styles.legendDot} style={{ backgroundColor: '#61d89e' }} /><span>Within daily goal</span></div>
                            <div className={styles.legendItem}><span className={styles.legendDot} style={{ backgroundColor: '#e08e8e' }} /><span>Exceeded daily goal</span></div>
                          </div>
                        </div>
                        <div className={styles.chartNote}>{usageAggregateData.goalAdherence.puffsSampled} puffs from {usageAggregateData.goalAdherence.sampleSize} users</div>
                      </div>
                      <div className={styles.chartCard}>
                        <h3>Suggestion Compliance</h3>
                        <div className={styles.emailStats}>
                          <div className={styles.emailStatRow}><span>Puff Duration Within Goal</span><span>{Math.round((1 - usageAggregateData.goalAdherence.exceededDurationRate) * 100)}%</span></div>
                          <div className={styles.emailStatRow}><span>Cluster Wait Respected</span><span>{Math.round((1 - usageAggregateData.goalAdherence.exceededClusterWaitRate) * 100)}%</span></div>
                          <div className={styles.emailStatRow}><span>Daily Total Within Goal</span><span>{Math.round((1 - usageAggregateData.goalAdherence.exceededDailyTotalRate) * 100)}%</span></div>
                        </div>
                        <div style={{ marginTop: '1.5rem' }}>
                          <h4 style={{ color: '#888', fontSize: '0.85rem', marginBottom: '0.5rem' }}>Totals</h4>
                          <div className={styles.emailStats}>
                            <div className={styles.emailStatRow}><span>Total Puffs</span><span>{usageAggregateData.summary.totalPuffs.toLocaleString()}</span></div>
                            <div className={styles.emailStatRow}><span>Total Duration</span><span>{Math.round(usageAggregateData.summary.totalDurationMs / 60000).toLocaleString()}m</span></div>
                            <div className={styles.emailStatRow}><span>Total Clusters</span><span>{usageAggregateData.summary.totalClusters.toLocaleString()}</span></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </>
            )}

            {/* INDIVIDUAL USER SUB-TAB */}
            {usageSubTab === 'individual' && (
              <>
                {/* User search */}
                <div className={styles.toolbar}>
                  <input type="text" placeholder="Search by email, username, or ID..." value={usageUserSearch} onChange={e => setUsageUserSearch(e.target.value)} className={styles.searchInput} />
                  <button onClick={() => {
                    const search = usageUserSearch.toLowerCase().trim();
                    if (!search) return;
                    // Check existing users list first
                    const match = users.find(u => u.email?.toLowerCase().includes(search) || u.userId.toLowerCase().includes(search) || u.username?.toLowerCase().includes(search));
                    if (match) { setUsageSelectedUserId(match.userId); fetchUsageUserData(match.userId, usageUserRange); }
                    else {
                      // Try direct userId lookup
                      setUsageSelectedUserId(search);
                      fetchUsageUserData(search, usageUserRange);
                    }
                  }} className={styles.actionBtn}><Icons.Search /> Load User</button>
                </div>

                {/* Quick-select from recent users */}
                {users.length > 0 && (
                  <div className={styles.filterGroup} style={{ marginBottom: '1rem', flexWrap: 'wrap' }}>
                    {users.slice(0, 10).map(u => (
                      <button key={u.userId} className={`${styles.filterBtn} ${usageSelectedUserId === u.userId ? styles.filterBtnActive : ''}`} onClick={() => { setUsageSelectedUserId(u.userId); fetchUsageUserData(u.userId, usageUserRange); }}>
                        {u.email?.split('@')[0] || u.username || u.userId.slice(0, 8)}
                      </button>
                    ))}
                  </div>
                )}

                {usageUserLoading ? <div className={styles.loadingState}>Loading user usage data...</div> : usageUserData && (
                  <>
                    {/* User header */}
                    <div style={{ marginBottom: '1.5rem', display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
                      <h2 style={{ margin: 0, color: '#fff' }}>{usageUserData.user.email || usageUserData.user.username || 'Unknown User'}</h2>
                      <span style={{ color: '#666', fontSize: '0.85rem' }}>{usageUserData.user.userId}</span>
                      <div style={{ display: 'flex', gap: '0.5rem' }}>
                        {usageUserData.user.hasQuit && <span className={styles.badgeQuit}>Quit</span>}
                        {!usageUserData.user.showAds && <span className={styles.badgePremium}>Premium</span>}
                        {usageUserData.user.platform && <span className={styles.badge}>{usageUserData.user.platform}</span>}
                        <span className={styles.badge}>{usageUserData.user.userRole}</span>
                      </div>
                    </div>

                    {/* Radial gauge + Tiles */}
                    <div className={styles.chartsRow}>
                      <div className={styles.chartCard} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: '200px' }}>
                        <RadialGauge usedMs={usageUserData.radial.usedMs} limitMs={usageUserData.radial.limitMs} calibrated={usageUserData.radial.calibrated} size={180} />
                      </div>
                      <div className={styles.chartCard} style={{ flex: 2 }}>
                        <h3>Today's Summary</h3>
                        <div className={styles.statsGrid}>
                          <StatCard label="Streak" value={`${usageUserData.tiles.streak}d`} icon={Icons.TrendingUp} color="green" />
                          <StatCard label="Puffs Today" value={usageUserData.tiles.puffCountToday} icon={Icons.Activity} color="blue" />
                          <StatCard label="Avg Puff" value={`${(usageUserData.tiles.avgPuffDurationMs / 1000).toFixed(1)}s`} icon={Icons.Zap} color="purple" />
                          <StatCard label="Cluster Wait" value={usageUserData.tiles.clusterWaitSuggestedMs > 0 ? `${Math.round(usageUserData.tiles.clusterWaitSuggestedMs / 60000)}m` : '—'} icon={Icons.Award} color="gold" />
                          <StatCard label="Calibration" value={usageUserData.tiles.calibrationDaysLeft !== null ? `${usageUserData.tiles.calibrationDaysLeft}d left` : 'Done'} icon={Icons.BarChart} color={usageUserData.tiles.calibrationDaysLeft !== null ? 'coral' : 'green'} />
                        </div>
                      </div>
                    </div>

                    {/* Bar chart with D/W/M/Y selector */}
                    <div className={styles.chartCard}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
                        <h3 style={{ margin: 0 }}>Usage History</h3>
                        <div className={styles.filterGroup}>
                          {[{ key: 'day', label: 'D' }, { key: 'week', label: 'W' }, { key: 'month', label: 'M' }, { key: 'year', label: 'Y' }].map(r => (
                            <button key={r.key} className={`${styles.filterBtn} ${usageUserRange === r.key ? styles.filterBtnActive : ''}`} onClick={() => { setUsageUserRange(r.key); fetchUsageUserData(usageUserData.user.userId, r.key); }}>{r.label}</button>
                          ))}
                        </div>
                      </div>
                      <VerticalBarChart data={usageUserData.series} dataKey="puffDurationTotal" labelKey="bucket" color="#61d89e" height={240} timeMode={usageUserData.timeMode || 'day'} />
                    </div>

                    {/* Goal flags + Trend */}
                    <div className={styles.chartsRow}>
                      <div className={styles.chartCard}>
                        <h3>Goal Adherence (Last {usageUserData.goalFlags.totalRecentPuffs} Puffs)</h3>
                        <div className={styles.emailStats}>
                          <div className={styles.emailStatRow}><span>Exceeded Daily Total</span><span>{usageUserData.goalFlags.exceededDurationCount} / {usageUserData.goalFlags.totalRecentPuffs}</span></div>
                          <div className={styles.emailStatRow}><span>Exceeded Cluster Wait</span><span>{usageUserData.goalFlags.exceededClusterWaitCount} / {usageUserData.goalFlags.totalRecentPuffs}</span></div>
                          <div className={styles.emailStatRow}><span>Exceeded Puff Duration Avg</span><span>{usageUserData.goalFlags.exceededPuffDurationAvgCount} / {usageUserData.goalFlags.totalRecentPuffs}</span></div>
                        </div>
                      </div>
                      <div className={styles.chartCard}>
                        <h3>Usage Trend</h3>
                        <div style={{ textAlign: 'center', padding: '1.5rem' }}>
                          <div style={{ fontSize: '2rem', fontWeight: 700, color: usageUserData.tiles.trendDirection === 'down' ? '#61d89e' : usageUserData.tiles.trendDirection === 'up' ? '#e08e8e' : '#888' }}>
                            {usageUserData.tiles.trendDirection === 'down' ? '↓' : usageUserData.tiles.trendDirection === 'up' ? '↑' : '→'} {usageUserData.tiles.trendPercent}%
                          </div>
                          <div style={{ color: '#888', fontSize: '0.85rem', marginTop: '0.5rem' }}>
                            {usageUserData.tiles.trendDirection === 'down' ? 'Usage decreasing (good!)' : usageUserData.tiles.trendDirection === 'up' ? 'Usage increasing' : 'Usage stable'}
                          </div>
                          <div style={{ color: '#555', fontSize: '0.75rem', marginTop: '0.25rem' }}>Last 3 days vs prior 3 days</div>
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {!usageUserLoading && !usageUserData && !usageSelectedUserId && (
                  <div style={{ textAlign: 'center', padding: '3rem', color: '#666' }}>
                    <Icons.Users /><p style={{ marginTop: '1rem' }}>Search for a user or select one from the list above to view their usage dashboard</p>
                  </div>
                )}
              </>
            )}
          </div>
        )}

        {/* STUDY TAB */}
        {activeTab === 'study' && (
          <div className={styles.tabContent}>
            {/* Study Sub-Tab Navigation */}
            <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1.5rem' }}>
              {['participants', 'scoring'].map(sub => (
                <button
                  key={sub}
                  className={`${styles.filterBtn} ${studySubTab === sub ? styles.filterBtnActive : ''}`}
                  onClick={() => setStudySubTab(sub)}
                >
                  {sub === 'participants' ? 'Participants' : 'Scoring'}
                </button>
              ))}
            </div>

            {studySubTab === 'participants' && (
            <>
            {studyLoading ? (
              <div className={styles.loadingState}>Loading study data...</div>
            ) : (
              <>
                {/* Study Stats Overview */}
                {studyStats && (
                  <div className={styles.statsGrid}>
                    <StatCard label="Total Participants" value={studyStats.totalParticipants || 0} icon={Icons.Users} color="purple" />
                    <StatCard label="Intake Completed" value={studyStats.intakeComplete || studyStats.intakeCompleted || 0} subtitle={studyStats.totalParticipants ? `${Math.round(((studyStats.intakeComplete || studyStats.intakeCompleted || 0) / studyStats.totalParticipants) * 100)}%` : '0%'} icon={Icons.Check} color="green" />
                    <StatCard label="Active (BLE Puff)" value={studyStats.studyStarted || studyStats.studyInProgress || 0} icon={Icons.Activity} color="blue" />
                    <StatCard label="Study Completed" value={studyStats.studyComplete || studyStats.studyCompleted || 0} subtitle={studyStats.totalParticipants ? `${Math.round(((studyStats.studyComplete || studyStats.studyCompleted || 0) / studyStats.totalParticipants) * 100)}%` : '0%'} icon={Icons.Award} color="gold" />
                  </div>
                )}

                {/* Create Cohort & Analytics */}
                <div className={styles.chartsRow}>
                  <div className={styles.chartCard}>
                    <h3>Create New Cohort</h3>
                    <div className={styles.formGroup}>
                      <label>Cohort Name</label>
                      <input
                        type="text"
                        value={newCohortName}
                        onChange={(e) => setNewCohortName(e.target.value)}
                        placeholder="e.g., Pilot Study Q1 2024"
                        className={styles.textInput}
                      />
                    </div>
                    <div className={styles.formGroup}>
                      <label>Default Duration (days)</label>
                      <input
                        type="number"
                        value={newCohortDuration}
                        onChange={(e) => setNewCohortDuration(e.target.value)}
                        min="7"
                        max="365"
                        className={styles.textInput}
                      />
                    </div>
                    <button onClick={createCohort} className={styles.btnPrimary}>
                      Create Cohort
                    </button>
                  </div>

                  {/* Study Analytics */}
                  <div className={styles.chartCard}>
                    <h3>Study Analytics</h3>
                    {studyStats && (
                      <div className={styles.emailStats}>
                        <div className={styles.emailStatRow}>
                          <span>Avg. Time to First Puff</span>
                          <span>{studyStats.avgTimeToFirstPuff ? `${studyStats.avgTimeToFirstPuff.toFixed(1)} hrs` : 'N/A'}</span>
                        </div>
                        <div className={styles.emailStatRow}>
                          <span>Avg. Intake to Study Start</span>
                          <span>{studyStats.avgIntakeToStudyStart ? `${studyStats.avgIntakeToStudyStart.toFixed(1)} hrs` : 'N/A'}</span>
                        </div>
                        <div className={styles.emailStatRow}>
                          <span>Avg. Reduction Rate</span>
                          <span>{studyStats.avgReductionRate ? `${studyStats.avgReductionRate.toFixed(1)}%` : 'N/A'}</span>
                        </div>
                        <div className={styles.emailStatRow}>
                          <span>Outtake Ready</span>
                          <span>{studyStats.outtakeReady || 0}</span>
                        </div>
                        <div className={styles.emailStatRow}>
                          <span>Outtake Completed</span>
                          <span>{studyStats.outtakeCompleted || 0}</span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Cohort Signup Links */}
                {studyCohorts.length > 0 && (
                  <div className={styles.tableCard} style={{ marginBottom: '1.5rem' }}>
                    <h3>Cohort Signup Links</h3>
                    <p style={{ color: '#888', fontSize: '0.85rem', marginBottom: '1rem' }}>
                      Generate signup links for users to self-enroll in studies
                    </p>
                    <div style={{ display: 'grid', gap: '0.75rem' }}>
                      {studyCohorts.map(cohort => (
                        <div key={cohort.id} style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          padding: '0.75rem 1rem',
                          background: '#2b2c2b',
                          borderRadius: '0.5rem',
                          gap: '1rem'
                        }}>
                          <div style={{ flex: 1 }}>
                            <div style={{ fontWeight: 600, color: '#fff' }}>{cohort.name}</div>
                            {cohort.signupToken && (
                              <div style={{ fontSize: '0.75rem', color: '#888', marginTop: '0.25rem' }}>
                                Link: /study/signup?token={cohort.signupToken.slice(0, 8)}...
                              </div>
                            )}
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                            {cohort.signupToken && (
                              <>
                                <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.8rem', color: '#888' }}>
                                  <input
                                    type="checkbox"
                                    checked={cohort.signupEnabled !== false}
                                    onChange={(e) => toggleCohortSignups(cohort.id, e.target.checked)}
                                    style={{ accentColor: '#61d89e' }}
                                  />
                                  Enabled
                                </label>
                                <button
                                  onClick={() => copySignupLink(cohort)}
                                  className={styles.btnSmall}
                                  style={{ minWidth: '70px' }}
                                >
                                  {copiedCohortId === cohort.id ? 'Copied!' : 'Copy'}
                                </button>
                              </>
                            )}
                            <button
                              onClick={() => generateSignupLink(cohort.id)}
                              disabled={signupLinkLoading === cohort.id}
                              className={styles.btnSmall}
                              style={{ minWidth: '100px' }}
                            >
                              {signupLinkLoading === cohort.id
                                ? 'Generating...'
                                : cohort.signupToken
                                  ? 'Regenerate'
                                  : 'Generate Link'
                              }
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Study Signups (Self-enrolled) */}
                {studySignups.length > 0 && (
                  <div className={styles.tableCard} style={{ marginBottom: '1.5rem' }}>
                    <h3>Self-Signups ({studySignups.length})</h3>
                    <DataTable
                      columns={[
                        { key: 'email', label: 'Email' },
                        {
                          key: 'status',
                          label: 'Status',
                          width: '100px',
                          render: val => (
                            <span className={`${styles.badge} ${
                              val === 'enrolled' ? styles.badgePaid :
                              val === 'verified' ? styles.badgePremium : ''
                            }`}>
                              {val}
                            </span>
                          )
                        },
                        {
                          key: 'createdAt',
                          label: 'Signed Up',
                          width: '120px',
                          render: val => val ? new Date(val).toLocaleDateString() : '—'
                        },
                        {
                          key: 'verifiedAt',
                          label: 'Verified',
                          width: '120px',
                          render: val => val ? new Date(val).toLocaleDateString() : '—'
                        },
                        {
                          key: 'actions',
                          label: '',
                          width: '60px',
                          render: (_, row) => (
                            <button
                              onClick={() => openDeleteModal(row, 'signup')}
                              className={styles.btnSmall}
                              style={{ color: '#e08e8e', borderColor: '#e08e8e' }}
                            >
                              <Icons.X />
                            </button>
                          )
                        }
                      ]}
                      data={studySignups.map(s => ({ ...s, id: s.id }))}
                      emptyMessage="No self-signups yet"
                    />
                  </div>
                )}

                {/* Cohort Filter */}
                <div className={styles.toolbar}>
                  <div className={styles.filterGroup}>
                    <button
                      className={`${styles.filterBtn} ${studyCohortFilter === null ? styles.filterBtnActive : ''}`}
                      onClick={() => setStudyCohortFilter(null)}
                    >
                      All Cohorts
                    </button>
                    {studyCohorts.map(cohort => (
                      <button
                        key={cohort.id}
                        className={`${styles.filterBtn} ${studyCohortFilter === cohort.id ? styles.filterBtnActive : ''}`}
                        onClick={() => setStudyCohortFilter(cohort.id)}
                      >
                        {cohort.name}
                      </button>
                    ))}
                  </div>
                  <button onClick={fetchStudyParticipants} className={styles.actionBtn}>
                    <Icons.RefreshCw /> Refresh
                  </button>
                  <button onClick={() => exportToCSV(studyParticipants, 'study-participants')} className={styles.actionBtn}>
                    <Icons.Download /> Export CSV
                  </button>
                </div>

                {/* Participants Table */}
                <DataTable
                  columns={[
                    {
                      key: 'email',
                      label: 'Participant',
                      render: (val, row) => (
                        <div className={styles.userCell}>
                          <span className={styles.userEmail}>{val || 'No email'}</span>
                          <span className={styles.userId}>{row.id?.slice(0, 8)}...</span>
                        </div>
                      )
                    },
                    {
                      key: 'cohort',
                      label: 'Cohort',
                      width: '110px',
                      render: val => <span className={styles.badge}>{val || '—'}</span>
                    },
                    {
                      key: 'status',
                      label: 'Status',
                      width: '130px',
                      render: (val, row) => {
                        const statusMap = {
                          enrolled: { label: 'Enrolled', style: {} },
                          intake_completed: { label: 'Intake Done', style: { background: 'rgba(98, 84, 186, 0.15)', color: '#a78bfa' } },
                          active: { label: 'Active', style: { background: 'rgba(97, 216, 158, 0.15)', color: '#61d89e' } },
                          study_completed: { label: 'Completed', style: { background: 'rgba(234, 179, 8, 0.15)', color: '#eab308' } },
                        };
                        const s = statusMap[val] || statusMap.enrolled;
                        return (
                          <span className={styles.badge} style={s.style}>
                            {row.hasFirstBlePuff && val !== 'enrolled' && val !== 'intake_completed' ? '● ' : ''}{s.label}
                          </span>
                        );
                      }
                    },
                    {
                      key: 'intakeCompletedAt',
                      label: 'Intake',
                      width: '90px',
                      render: val => val ? formatTimeAgo(val) : '—'
                    },
                    {
                      key: 'studyStartedAt',
                      label: '1st Puff',
                      width: '90px',
                      render: (val, row) => row.hasFirstBlePuff
                        ? <span style={{ color: '#61d89e' }}>{val ? formatTimeAgo(val) : 'Yes'}</span>
                        : <span style={{ color: '#666' }}>—</span>
                    },
                    {
                      key: 'studyEndDateFormatted',
                      label: 'End Date',
                      width: '95px',
                      render: (val, row) => {
                        if (row.status === 'study_completed') return <span style={{ color: '#61d89e' }}>{val || 'Done'}</span>;
                        return val || '—';
                      }
                    },
                    {
                      key: 'daysRemaining',
                      label: 'Days Left',
                      width: '70px',
                      render: (val, row) => {
                        if (row.status === 'study_completed') return <span style={{ color: '#61d89e' }}>0</span>;
                        if (!row.studyStartedAt) return '—';
                        return val !== undefined ? `${val}` : '—';
                      }
                    },
                    {
                      key: 'outtakeCompletedAt',
                      label: 'Outtake',
                      width: '90px',
                      render: val => val ? formatTimeAgo(val) : '—'
                    },
                    {
                      key: 'actions',
                      label: '',
                      width: '120px',
                      render: (_, row) => (
                        <div style={{ display: 'flex', gap: '0.25rem' }}>
                          {!row.studyStartedAt && row.intakeCompletedAt && (
                            <button onClick={() => startStudy(row.id)} className={styles.btnSmall}>
                              Start Study
                            </button>
                          )}
                          <button
                            onClick={() => openDeleteModal(row, 'participant')}
                            className={styles.btnSmall}
                            style={{ color: '#e08e8e', borderColor: '#e08e8e' }}
                          >
                            <Icons.X />
                          </button>
                        </div>
                      )
                    }
                  ]}
                  data={studyParticipants.map(p => ({ ...p, id: p.id }))}
                  emptyMessage="No study participants found"
                />
              </>
            )}
            </>
            )}

            {/* SCORING SUB-TAB */}
            {studySubTab === 'scoring' && (
              <>
                {/* Cohort Filter */}
                <div className={styles.toolbar} style={{ marginBottom: '1.5rem' }}>
                  <div className={styles.filterGroup}>
                    <button className={`${styles.filterBtn} ${studyCohortFilter === null ? styles.filterBtnActive : ''}`} onClick={() => setStudyCohortFilter(null)}>All Cohorts</button>
                    {studyCohorts.map(cohort => (
                      <button key={cohort.id} className={`${styles.filterBtn} ${studyCohortFilter === cohort.id ? styles.filterBtnActive : ''}`} onClick={() => setStudyCohortFilter(cohort.id)}>{cohort.name}</button>
                    ))}
                  </div>
                  <button onClick={fetchStudyScoring} className={styles.actionBtn}><Icons.RefreshCw /> Refresh</button>
                </div>

                {scoringLoading ? (
                  <div className={styles.loadingState}>Loading scoring data...</div>
                ) : scoringData ? (
                  <>
                    {/* Cohort Summary Cards */}
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '1rem', marginBottom: '1.5rem' }}>
                      {(() => {
                        const cs = scoringData.cohortSummary;
                        const fmt = (v) => v !== null && v !== undefined ? v.toFixed(1) : '—';
                        const fmtSD = (obj) => obj?.mean !== null && obj?.mean !== undefined ? `${obj.mean.toFixed(1)}${obj.sd !== null ? ` (±${obj.sd.toFixed(1)})` : ''}` : '—';
                        const changeColor = (val, lower) => val === null || val === undefined ? '#888' : (lower ? val < 0 : val > 0) ? '#61d89e' : val === 0 ? '#888' : '#e08e8e';
                        const changeArrow = (val, lower) => val === null || val === undefined ? '' : (lower ? val < 0 : val > 0) ? '↓ ' : val === 0 ? '→ ' : '↑ ';

                        return [
                          { label: 'PSECDI', sub: '0-20 (dependence)', intake: fmtSD({ mean: cs.intake?.mean, sd: cs.intake?.sd }), outtake: fmtSD(cs.outtake?.psecdi), change: cs.change?.psecdi?.mean, lowerBetter: true },
                          { label: 'PSS-4', sub: '0-16 (stress)', intake: fmtSD(cs.intake?.pss4), outtake: fmtSD(cs.outtake?.pss4), change: cs.change?.pss4?.mean, lowerBetter: true },
                          { label: 'Self-Efficacy', sub: '1-10 (confidence)', intake: fmtSD(cs.intake?.selfEfficacy), outtake: fmtSD(cs.outtake?.selfEfficacy), change: cs.change?.selfEfficacy?.mean, lowerBetter: false },
                          { label: 'Avg Sessions/Day', sub: 'usage', intake: fmt(cs.intake?.avgDailySessions?.mean), outtake: '—', change: null, lowerBetter: true },
                          { label: 'Reduction %', sub: 'outtake only', intake: '—', outtake: fmtSD(cs.outtake?.reductionPercent), change: null, lowerBetter: false },
                          { label: 'NPS', sub: '0-10', intake: '—', outtake: fmtSD(cs.outtake?.nps), change: null, lowerBetter: false },
                        ].map(card => (
                          <div key={card.label} style={{ background: '#2b2c2b', borderRadius: '0.75rem', padding: '1rem' }}>
                            <div style={{ fontSize: '0.75rem', color: '#888', marginBottom: '0.25rem' }}>{card.sub}</div>
                            <div style={{ fontSize: '1rem', fontWeight: 700, marginBottom: '0.75rem' }}>{card.label}</div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.85rem', marginBottom: '0.25rem' }}>
                              <span style={{ color: '#888' }}>Intake</span>
                              <span>{card.intake}</span>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.85rem', marginBottom: '0.25rem' }}>
                              <span style={{ color: '#888' }}>Outtake</span>
                              <span>{card.outtake}</span>
                            </div>
                            {card.change !== null && card.change !== undefined && (
                              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.85rem', borderTop: '1px solid #3a3b3a', paddingTop: '0.5rem', marginTop: '0.5rem' }}>
                                <span style={{ color: '#888' }}>Change</span>
                                <span style={{ color: changeColor(card.change, card.lowerBetter), fontWeight: 600 }}>
                                  {changeArrow(card.change, card.lowerBetter)}{fmt(card.change)}
                                </span>
                              </div>
                            )}
                          </div>
                        ));
                      })()}
                    </div>

                    <div style={{ fontSize: '0.8rem', color: '#888', marginBottom: '0.75rem' }}>
                      n={scoringData.cohortSummary.n} · Intake: {scoringData.cohortSummary.intakeCount} · Outtake: {scoringData.cohortSummary.outtakeCount}
                    </div>

                    {/* Individual Scores Table */}
                    <div className={styles.tableCard}>
                      <h3>Individual Scores</h3>
                      <div style={{ overflowX: 'auto' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.85rem' }}>
                          <thead>
                            <tr style={{ borderBottom: '1px solid #3a3b3a' }}>
                              <th style={{ textAlign: 'left', padding: '0.75rem 0.5rem', color: '#888', fontWeight: 600 }}>Participant</th>
                              <th style={{ textAlign: 'center', padding: '0.75rem 0.5rem', color: '#888', fontWeight: 600 }}>Status</th>
                              <th style={{ textAlign: 'center', padding: '0.75rem 0.5rem', color: '#888', fontWeight: 600 }} colSpan="3">PSECDI (0-20)</th>
                              <th style={{ textAlign: 'center', padding: '0.75rem 0.5rem', color: '#888', fontWeight: 600 }} colSpan="3">PSS-4 (0-16)</th>
                              <th style={{ textAlign: 'center', padding: '0.75rem 0.5rem', color: '#888', fontWeight: 600 }} colSpan="2">Self-Efficacy</th>
                              <th style={{ textAlign: 'center', padding: '0.75rem 0.5rem', color: '#888', fontWeight: 600 }} colSpan="2">Sessions/Day</th>
                              <th style={{ textAlign: 'center', padding: '0.75rem 0.5rem', color: '#888', fontWeight: 600 }}>Reduction</th>
                              <th style={{ textAlign: 'center', padding: '0.75rem 0.5rem', color: '#888', fontWeight: 600 }}>NPS</th>
                            </tr>
                            <tr style={{ borderBottom: '1px solid #3a3b3a' }}>
                              <th></th><th></th>
                              <th style={{ textAlign: 'center', padding: '0.25rem 0.5rem', color: '#666', fontWeight: 400, fontSize: '0.75rem' }}>In</th>
                              <th style={{ textAlign: 'center', padding: '0.25rem 0.5rem', color: '#666', fontWeight: 400, fontSize: '0.75rem' }}>Out</th>
                              <th style={{ textAlign: 'center', padding: '0.25rem 0.5rem', color: '#666', fontWeight: 400, fontSize: '0.75rem' }}>Δ</th>
                              <th style={{ textAlign: 'center', padding: '0.25rem 0.5rem', color: '#666', fontWeight: 400, fontSize: '0.75rem' }}>In</th>
                              <th style={{ textAlign: 'center', padding: '0.25rem 0.5rem', color: '#666', fontWeight: 400, fontSize: '0.75rem' }}>Out</th>
                              <th style={{ textAlign: 'center', padding: '0.25rem 0.5rem', color: '#666', fontWeight: 400, fontSize: '0.75rem' }}>Δ</th>
                              <th style={{ textAlign: 'center', padding: '0.25rem 0.5rem', color: '#666', fontWeight: 400, fontSize: '0.75rem' }}>In</th>
                              <th style={{ textAlign: 'center', padding: '0.25rem 0.5rem', color: '#666', fontWeight: 400, fontSize: '0.75rem' }}>Out</th>
                              <th style={{ textAlign: 'center', padding: '0.25rem 0.5rem', color: '#666', fontWeight: 400, fontSize: '0.75rem' }}>In</th>
                              <th style={{ textAlign: 'center', padding: '0.25rem 0.5rem', color: '#666', fontWeight: 400, fontSize: '0.75rem' }}>Out</th>
                              <th style={{ textAlign: 'center', padding: '0.25rem 0.5rem', color: '#666', fontWeight: 400, fontSize: '0.75rem' }}>%</th>
                              <th style={{ textAlign: 'center', padding: '0.25rem 0.5rem', color: '#666', fontWeight: 400, fontSize: '0.75rem' }}>Score</th>
                            </tr>
                          </thead>
                          <tbody>
                            {scoringData.participants.map(p => {
                              const v = (val) => val !== null && val !== undefined ? val : '—';
                              const chg = (val, lowerBetter) => {
                                if (val === null || val === undefined) return <span style={{ color: '#666' }}>—</span>;
                                const good = lowerBetter ? val < 0 : val > 0;
                                const color = val === 0 ? '#888' : good ? '#61d89e' : '#e08e8e';
                                return <span style={{ color, fontWeight: 600 }}>{val > 0 ? '+' : ''}{val}</span>;
                              };
                              const psecdiColor = (val) => {
                                if (val === null || val === undefined) return {};
                                if (val <= 3) return { color: '#61d89e' };
                                if (val <= 8) return { color: '#eab308' };
                                return { color: '#e08e8e' };
                              };
                              const pss4Color = (val) => {
                                if (val === null || val === undefined) return {};
                                if (val <= 4) return { color: '#61d89e' };
                                if (val <= 8) return { color: '#eab308' };
                                return { color: '#e08e8e' };
                              };
                              const npsColor = (val) => {
                                if (val === null || val === undefined) return {};
                                if (val >= 9) return { color: '#61d89e' };
                                if (val >= 7) return { color: '#eab308' };
                                return { color: '#e08e8e' };
                              };
                              const reductionColor = (val) => {
                                if (val === null || val === undefined) return {};
                                if (val >= 50) return { color: '#61d89e' };
                                if (val >= 25) return { color: '#eab308' };
                                return { color: '#e08e8e' };
                              };

                              const isExpanded = expandedScoringRow === p.id;

                              return (
                                <React.Fragment key={p.id}>
                                  <tr
                                    style={{ borderBottom: '1px solid #2a2b2a', cursor: 'pointer' }}
                                    onClick={() => setExpandedScoringRow(isExpanded ? null : p.id)}
                                  >
                                    <td style={{ padding: '0.6rem 0.5rem' }}>
                                      <div className={styles.userCell}>
                                        <span className={styles.userEmail}>{p.email}</span>
                                      </div>
                                    </td>
                                    <td style={{ textAlign: 'center', padding: '0.6rem 0.5rem' }}>
                                      <span className={styles.badge} style={
                                        p.status === 'active' ? { background: 'rgba(97,216,158,0.15)', color: '#61d89e' } :
                                        p.status === 'study_completed' ? { background: 'rgba(234,179,8,0.15)', color: '#eab308' } :
                                        p.status === 'intake_completed' ? { background: 'rgba(98,84,186,0.15)', color: '#a78bfa' } : {}
                                      }>{p.status?.replace(/_/g, ' ') || 'enrolled'}</span>
                                    </td>
                                    <td style={{ textAlign: 'center', padding: '0.6rem 0.5rem', ...psecdiColor(p.intake?.psecdiScore) }}>{v(p.intake?.psecdiScore)}</td>
                                    <td style={{ textAlign: 'center', padding: '0.6rem 0.5rem', ...psecdiColor(p.outtake?.psecdiScore) }}>{v(p.outtake?.psecdiScore)}</td>
                                    <td style={{ textAlign: 'center', padding: '0.6rem 0.5rem' }}>{chg(p.change?.psecdiChange, true)}</td>
                                    <td style={{ textAlign: 'center', padding: '0.6rem 0.5rem', ...pss4Color(p.intake?.pss4Score) }}>{v(p.intake?.pss4Score)}</td>
                                    <td style={{ textAlign: 'center', padding: '0.6rem 0.5rem', ...pss4Color(p.outtake?.pss4Score) }}>{v(p.outtake?.pss4Score)}</td>
                                    <td style={{ textAlign: 'center', padding: '0.6rem 0.5rem' }}>{chg(p.change?.pss4Change, true)}</td>
                                    <td style={{ textAlign: 'center', padding: '0.6rem 0.5rem' }}>{v(p.intake?.selfEfficacy)}</td>
                                    <td style={{ textAlign: 'center', padding: '0.6rem 0.5rem' }}>{v(p.outtake?.selfEfficacy)}</td>
                                    <td style={{ textAlign: 'center', padding: '0.6rem 0.5rem' }}>{v(p.intake?.avgDailySessions)}</td>
                                    <td style={{ textAlign: 'center', padding: '0.6rem 0.5rem' }}>{v(p.outtake?.currentDailySessions)}</td>
                                    <td style={{ textAlign: 'center', padding: '0.6rem 0.5rem', ...reductionColor(p.outtake?.reductionPercent) }}>{p.outtake?.reductionPercent !== null && p.outtake?.reductionPercent !== undefined ? `${p.outtake.reductionPercent.toFixed(0)}%` : '—'}</td>
                                    <td style={{ textAlign: 'center', padding: '0.6rem 0.5rem', ...npsColor(p.outtake?.npsScore) }}>{v(p.outtake?.npsScore)}</td>
                                  </tr>
                                  {isExpanded && p.intake && (
                                    <tr>
                                      <td colSpan="14" style={{ padding: '1rem', background: '#1e1f1e', borderBottom: '1px solid #3a3b3a' }}>
                                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem', fontSize: '0.8rem' }}>
                                          <div>
                                            <div style={{ fontWeight: 600, marginBottom: '0.5rem', color: '#a78bfa' }}>Fagerström Items (Intake)</div>
                                            <div style={{ color: '#999' }}>Time to first vape: <span style={{ color: '#fff' }}>{p.intake.timeToFirstVape?.replace(/_/g, ' ') || '—'}</span></div>
                                            <div style={{ color: '#999' }}>Difficulty refraining: <span style={{ color: '#fff' }}>{v(p.intake.difficultyRefraining)}/5</span></div>
                                            <div style={{ color: '#999' }}>Most hate to give up: <span style={{ color: '#fff' }}>{p.intake.mostDifficultVape?.replace(/_/g, ' ') || '—'}</span></div>
                                            <div style={{ color: '#999' }}>Vaping when ill: <span style={{ color: '#fff' }}>{p.intake.vapingWhenIll || '—'}</span></div>
                                          </div>
                                          <div>
                                            <div style={{ fontWeight: 600, marginBottom: '0.5rem', color: '#61d89e' }}>Usage & Health (Intake)</div>
                                            <div style={{ color: '#999' }}>Avg daily sessions: <span style={{ color: '#fff' }}>{v(p.intake.avgDailySessions)}</span></div>
                                            <div style={{ color: '#999' }}>Motivation to quit: <span style={{ color: '#fff' }}>{v(p.intake.motivationToQuit)}/10</span></div>
                                            <div style={{ color: '#999' }}>Self-rated health: <span style={{ color: '#fff' }}>{v(p.intake.selfRatedHealth)}/5</span></div>
                                            <div style={{ color: '#999' }}>Sleep quality: <span style={{ color: '#fff' }}>{v(p.intake.sleepQuality)}/5</span></div>
                                          </div>
                                          <div>
                                            <div style={{ fontWeight: 600, marginBottom: '0.5rem', color: '#eab308' }}>Triggers & Symptoms</div>
                                            <div style={{ color: '#999' }}>Triggers: <span style={{ color: '#fff' }}>{p.intake.triggers?.length ? p.intake.triggers.join(', ') : '—'}</span></div>
                                            <div style={{ color: '#999' }}>Respiratory: <span style={{ color: '#fff' }}>{p.intake.respiratorySymptoms?.length ? p.intake.respiratorySymptoms.join(', ') : 'none'}</span></div>
                                          </div>
                                          {p.outtake && (
                                            <div>
                                              <div style={{ fontWeight: 600, marginBottom: '0.5rem', color: '#3b82f6' }}>Outtake Details</div>
                                              <div style={{ color: '#999' }}>Current sessions/day: <span style={{ color: '#fff' }}>{v(p.outtake.currentDailySessions)}</span></div>
                                              <div style={{ color: '#999' }}>Self-reported reduction: <span style={{ color: '#fff' }}>{p.outtake.overallReduction?.replace(/_/g, ' ') || '—'}</span></div>
                                              <div style={{ color: '#999' }}>Satisfaction: <span style={{ color: '#fff' }}>{v(p.outtake.overallSatisfaction)}/5</span></div>
                                              <div style={{ color: '#999' }}>Trigger awareness: <span style={{ color: '#fff' }}>{v(p.outtake.triggerAwareness)}/5</span></div>
                                              <div style={{ color: '#999' }}>Maintenance confidence: <span style={{ color: '#fff' }}>{v(p.outtake.maintenanceConfidence)}/5</span></div>
                                              <div style={{ color: '#999' }}>Sleep quality: <span style={{ color: '#fff' }}>{v(p.outtake.sleepQuality)}/5</span></div>
                                            </div>
                                          )}
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                </React.Fragment>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                      {scoringData.participants.length === 0 && (
                        <div style={{ textAlign: 'center', padding: '2rem', color: '#666' }}>No scoring data available</div>
                      )}
                    </div>
                  </>
                ) : (
                  <div style={{ textAlign: 'center', padding: '2rem', color: '#666' }}>Click Refresh to load scoring data</div>
                )}
              </>
            )}
          </div>
        )}

        {/* TESTING TAB */}
        {activeTab === 'testing' && (
          <div className={styles.tabContent}>
            <TestingPanel functions={functions} />
          </div>
        )}

        {selectedUserId && <UserDetailModal userId={selectedUserId} onClose={() => setSelectedUserId(null)} onUpdate={() => fetchUsers()} />}

        <DeleteConfirmModal
          isOpen={deleteModal.open}
          onClose={closeDeleteModal}
          onConfirm={handleDeleteConfirm}
          title={deleteModal.type === 'signup' ? 'Remove Signup' : 'Remove Participant'}
          message={deleteModal.type === 'signup'
            ? 'Are you sure you want to remove this signup? If they are already enrolled, they will also be removed from the study.'
            : 'Are you sure you want to remove this participant from the study?'
          }
          itemName={deleteModal.participant?.email || ''}
          showDeleteSurveys={deleteModal.type === 'participant' || (deleteModal.type === 'signup' && deleteModal.participant?.status === 'enrolled')}
          loading={deleteLoading}
        />
      </div>
    </div>
  );
};

export default AdminAccount;